import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Button, Image, MinorHeader, Paragraph, PropsConsList, SemiBold, Table, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(1705);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-payment-gateway");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoPaymentGateway", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("seoPaymentGateway:seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seoPaymentGateway:seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      title: t2,
      description: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("seoPaymentGateway:header.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("seoPaymentGateway:header.intro");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <p>{t6}</p>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("seoPaymentGateway:header.button");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = LINKS();
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = {
      label: t8,
      to: t9.registration
    };
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("seoPaymentGateway:sections.1.title");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = <Trans t={t} i18nKey="seoPaymentGateway:sections.1.content" components={t12} />;
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13) {
    t14 = {
      title: t11,
      content: t13
    };
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t) {
    t15 = t("seoPaymentGateway:sections.2.title");
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      paragraph: <Paragraph />
    };
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = <Trans t={t} i18nKey="seoPaymentGateway:sections.2.content1" components={t16} />;
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t) {
    t18 = t("seoPaymentGateway:sections.2.title");
    $[32] = t;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t18) {
    t19 = <Image src="/images/sections/seoPaymentGateway/cs/1.png" width={768} height={325} isRounded={true} alt={t18} className="mb-8" />;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = <Trans t={t} i18nKey="seoPaymentGateway:sections.2.content2" components={t20} />;
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t17 || $[40] !== t19 || $[41] !== t21) {
    t22 = <>{t17}{t19}{t21}</>;
    $[39] = t17;
    $[40] = t19;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t15 || $[44] !== t22) {
    t23 = {
      title: t15,
      content: t22
    };
    $[43] = t15;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t("seoPaymentGateway:sections.3.title");
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t) {
    t26 = <Trans t={t} i18nKey="seoPaymentGateway:sections.3.content" components={t25} />;
    $[49] = t;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t24 || $[52] !== t26) {
    t27 = {
      title: t24,
      content: t26
    };
    $[51] = t24;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t) {
    t28 = t("seoPaymentGateway:sections.4.title");
    $[54] = t;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t) {
    t29 = t("seoPaymentGateway:sections.4.subsections.1.title");
    $[56] = t;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t) {
    t31 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.1.content" components={t30} />;
    $[59] = t;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      minorheader: <MinorHeader />
    };
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== t) {
    t33 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.1.subtitle1" components={t32} />;
    $[62] = t;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = [...Array(3)];
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] !== t) {
    t35 = <PropsConsList items={t34.map((_, i) => {
      const transIndex = i + 1 as NumericRange<1, 3>;
      return <Trans key={i} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.1.props.${transIndex}`} />;
    })} variant="props" />;
    $[65] = t;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      minorheader: <MinorHeader />
    };
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t) {
    t37 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.1.subtitle2" components={t36} />;
    $[68] = t;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = [...Array(3)];
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t) {
    t39 = <PropsConsList items={t38.map((__0, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 3>;
      return <Trans key={i_0} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.1.cons.${transIndex_0}`} />;
    })} variant="cons" />;
    $[71] = t;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t) {
    t40 = t("seoPaymentGateway:sections.4.subsections.1.table.headers.1");
    $[73] = t;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] !== t40) {
    t41 = <th className="w-56 rounded-tr-none!">{t40}</th>;
    $[75] = t40;
    $[76] = t41;
  } else {
    t41 = $[76];
  }
  let t42;
  if ($[77] !== t) {
    t42 = t("seoPaymentGateway:sections.4.subsections.1.table.headers.2");
    $[77] = t;
    $[78] = t42;
  } else {
    t42 = $[78];
  }
  let t43;
  if ($[79] !== t42) {
    t43 = <th colSpan={2} className="w-64">{t42}</th>;
    $[79] = t42;
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== t) {
    t44 = t("seoPaymentGateway:sections.4.subsections.1.table.headers.3");
    $[81] = t;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== t44) {
    t45 = <th colSpan={2} className="w-64 rounded-tr-md">{t44}</th>;
    $[83] = t44;
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== t41 || $[86] !== t43 || $[87] !== t45) {
    t46 = <tr>{t41}{t43}{t45}</tr>;
    $[85] = t41;
    $[86] = t43;
    $[87] = t45;
    $[88] = t46;
  } else {
    t46 = $[88];
  }
  let t47;
  if ($[89] !== t) {
    t47 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.1.columns.1");
    $[89] = t;
    $[90] = t47;
  } else {
    t47 = $[90];
  }
  let t48;
  if ($[91] !== t47) {
    t48 = <td className="w-56">{t47}</td>;
    $[91] = t47;
    $[92] = t48;
  } else {
    t48 = $[92];
  }
  let t49;
  if ($[93] !== t) {
    t49 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.1.columns.2");
    $[93] = t;
    $[94] = t49;
  } else {
    t49 = $[94];
  }
  let t50;
  if ($[95] !== t49) {
    t50 = <td colSpan={2} className="w-64 text-left!">{t49}</td>;
    $[95] = t49;
    $[96] = t50;
  } else {
    t50 = $[96];
  }
  let t51;
  if ($[97] !== t) {
    t51 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.1.columns.3");
    $[97] = t;
    $[98] = t51;
  } else {
    t51 = $[98];
  }
  let t52;
  if ($[99] !== t51) {
    t52 = <td colSpan={2} className="w-64 text-left!">{t51}</td>;
    $[99] = t51;
    $[100] = t52;
  } else {
    t52 = $[100];
  }
  let t53;
  if ($[101] !== t48 || $[102] !== t50 || $[103] !== t52) {
    t53 = <tr>{t48}{t50}{t52}</tr>;
    $[101] = t48;
    $[102] = t50;
    $[103] = t52;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  let t54;
  if ($[105] !== t) {
    t54 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.2.columns.1");
    $[105] = t;
    $[106] = t54;
  } else {
    t54 = $[106];
  }
  let t55;
  if ($[107] !== t54) {
    t55 = <td className="w-56">{t54}</td>;
    $[107] = t54;
    $[108] = t55;
  } else {
    t55 = $[108];
  }
  let t56;
  if ($[109] !== t) {
    t56 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.2.columns.2");
    $[109] = t;
    $[110] = t56;
  } else {
    t56 = $[110];
  }
  let t57;
  if ($[111] !== t56) {
    t57 = <td colSpan={2} className="w-64 text-left!">{t56}</td>;
    $[111] = t56;
    $[112] = t57;
  } else {
    t57 = $[112];
  }
  let t58;
  if ($[113] !== t) {
    t58 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.2.columns.3");
    $[113] = t;
    $[114] = t58;
  } else {
    t58 = $[114];
  }
  let t59;
  if ($[115] !== t58) {
    t59 = <td colSpan={2} className="w-64 text-left!">{t58}</td>;
    $[115] = t58;
    $[116] = t59;
  } else {
    t59 = $[116];
  }
  let t60;
  if ($[117] !== t55 || $[118] !== t57 || $[119] !== t59) {
    t60 = <tr>{t55}{t57}{t59}</tr>;
    $[117] = t55;
    $[118] = t57;
    $[119] = t59;
    $[120] = t60;
  } else {
    t60 = $[120];
  }
  let t61;
  if ($[121] !== t) {
    t61 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.3.columns.1");
    $[121] = t;
    $[122] = t61;
  } else {
    t61 = $[122];
  }
  let t62;
  if ($[123] !== t61) {
    t62 = <td className="w-56 text-left!">{t61}</td>;
    $[123] = t61;
    $[124] = t62;
  } else {
    t62 = $[124];
  }
  let t63;
  if ($[125] !== t) {
    t63 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.3.columns.2");
    $[125] = t;
    $[126] = t63;
  } else {
    t63 = $[126];
  }
  let t64;
  if ($[127] !== t63) {
    t64 = <td colSpan={2} className="w-64 text-left!">{t63}</td>;
    $[127] = t63;
    $[128] = t64;
  } else {
    t64 = $[128];
  }
  let t65;
  if ($[129] !== t) {
    t65 = t("seoPaymentGateway:sections.4.subsections.1.table.rows.3.columns.3");
    $[129] = t;
    $[130] = t65;
  } else {
    t65 = $[130];
  }
  let t66;
  if ($[131] !== t65) {
    t66 = <td colSpan={2} className="w-64 text-left!">{t65}</td>;
    $[131] = t65;
    $[132] = t66;
  } else {
    t66 = $[132];
  }
  let t67;
  if ($[133] !== t62 || $[134] !== t64 || $[135] !== t66) {
    t67 = <tr>{t62}{t64}{t66}</tr>;
    $[133] = t62;
    $[134] = t64;
    $[135] = t66;
    $[136] = t67;
  } else {
    t67 = $[136];
  }
  let t68;
  if ($[137] !== t53 || $[138] !== t60 || $[139] !== t67) {
    t68 = <>{t53}{t60}{t67}</>;
    $[137] = t53;
    $[138] = t60;
    $[139] = t67;
    $[140] = t68;
  } else {
    t68 = $[140];
  }
  let t69;
  if ($[141] !== t) {
    t69 = t("seoPaymentGateway:sections.4.subsections.1.table.notes");
    $[141] = t;
    $[142] = t69;
  } else {
    t69 = $[142];
  }
  let t70;
  if ($[143] !== t69) {
    t70 = [t69];
    $[143] = t69;
    $[144] = t70;
  } else {
    t70 = $[144];
  }
  let t71;
  if ($[145] !== t46 || $[146] !== t68 || $[147] !== t70) {
    t71 = <Table head={t46} body={t68} notes={t70} className="mt-8 mb-16" />;
    $[145] = t46;
    $[146] = t68;
    $[147] = t70;
    $[148] = t71;
  } else {
    t71 = $[148];
  }
  let t72;
  if ($[149] !== t31 || $[150] !== t33 || $[151] !== t35 || $[152] !== t37 || $[153] !== t39 || $[154] !== t71) {
    t72 = <>{t31}{t33}{t35}{t37}{t39}{t71}</>;
    $[149] = t31;
    $[150] = t33;
    $[151] = t35;
    $[152] = t37;
    $[153] = t39;
    $[154] = t71;
    $[155] = t72;
  } else {
    t72 = $[155];
  }
  let t73;
  if ($[156] !== t29 || $[157] !== t72) {
    t73 = {
      title: t29,
      content: t72
    };
    $[156] = t29;
    $[157] = t72;
    $[158] = t73;
  } else {
    t73 = $[158];
  }
  let t74;
  if ($[159] !== t) {
    t74 = t("seoPaymentGateway:sections.4.subsections.2.title");
    $[159] = t;
    $[160] = t74;
  } else {
    t74 = $[160];
  }
  let t75;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[161] = t75;
  } else {
    t75 = $[161];
  }
  let t76;
  if ($[162] !== t) {
    t76 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.2.content" components={t75} />;
    $[162] = t;
    $[163] = t76;
  } else {
    t76 = $[163];
  }
  let t77;
  if ($[164] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = {
      minorheader: <MinorHeader />
    };
    $[164] = t77;
  } else {
    t77 = $[164];
  }
  let t78;
  if ($[165] !== t) {
    t78 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.2.subtitle1" components={t77} />;
    $[165] = t;
    $[166] = t78;
  } else {
    t78 = $[166];
  }
  let t79;
  if ($[167] !== t) {
    t79 = t("seoPaymentGateway:sections.4.subsections.2.props");
    $[167] = t;
    $[168] = t79;
  } else {
    t79 = $[168];
  }
  let t80;
  if ($[169] !== t79) {
    t80 = <PropsConsList items={[t79]} variant="props" />;
    $[169] = t79;
    $[170] = t80;
  } else {
    t80 = $[170];
  }
  let t81;
  if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = {
      minorheader: <MinorHeader />
    };
    $[171] = t81;
  } else {
    t81 = $[171];
  }
  let t82;
  if ($[172] !== t) {
    t82 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.2.subtitle2" components={t81} />;
    $[172] = t;
    $[173] = t82;
  } else {
    t82 = $[173];
  }
  let t83;
  if ($[174] !== t) {
    t83 = t("seoPaymentGateway:sections.4.subsections.2.cons");
    $[174] = t;
    $[175] = t83;
  } else {
    t83 = $[175];
  }
  let t84;
  if ($[176] !== t83) {
    t84 = <PropsConsList items={[t83]} variant="cons" />;
    $[176] = t83;
    $[177] = t84;
  } else {
    t84 = $[177];
  }
  let t85;
  if ($[178] !== t) {
    t85 = t("seoPaymentGateway:sections.4.subsections.2.table.headers.1");
    $[178] = t;
    $[179] = t85;
  } else {
    t85 = $[179];
  }
  let t86;
  if ($[180] !== t85) {
    t86 = <th className="w-56 rounded-tr-none!">{t85}</th>;
    $[180] = t85;
    $[181] = t86;
  } else {
    t86 = $[181];
  }
  let t87;
  if ($[182] !== t) {
    t87 = t("seoPaymentGateway:sections.4.subsections.2.table.headers.2");
    $[182] = t;
    $[183] = t87;
  } else {
    t87 = $[183];
  }
  let t88;
  if ($[184] !== t87) {
    t88 = <th colSpan={2} className="w-64">{t87}</th>;
    $[184] = t87;
    $[185] = t88;
  } else {
    t88 = $[185];
  }
  let t89;
  if ($[186] !== t) {
    t89 = t("seoPaymentGateway:sections.4.subsections.2.table.headers.3");
    $[186] = t;
    $[187] = t89;
  } else {
    t89 = $[187];
  }
  let t90;
  if ($[188] !== t89) {
    t90 = <th colSpan={2} className="w-64 rounded-tr-md">{t89}</th>;
    $[188] = t89;
    $[189] = t90;
  } else {
    t90 = $[189];
  }
  let t91;
  if ($[190] !== t86 || $[191] !== t88 || $[192] !== t90) {
    t91 = <tr>{t86}{t88}{t90}</tr>;
    $[190] = t86;
    $[191] = t88;
    $[192] = t90;
    $[193] = t91;
  } else {
    t91 = $[193];
  }
  let t92;
  if ($[194] !== t) {
    t92 = t("seoPaymentGateway:sections.4.subsections.2.table.rows.1.columns.1");
    $[194] = t;
    $[195] = t92;
  } else {
    t92 = $[195];
  }
  let t93;
  if ($[196] !== t92) {
    t93 = <td className="w-56">{t92}</td>;
    $[196] = t92;
    $[197] = t93;
  } else {
    t93 = $[197];
  }
  let t94;
  if ($[198] !== t) {
    t94 = t("seoPaymentGateway:sections.4.subsections.2.table.rows.1.columns.2");
    $[198] = t;
    $[199] = t94;
  } else {
    t94 = $[199];
  }
  let t95;
  if ($[200] !== t94) {
    t95 = <td colSpan={2} className="w-64 text-left!">{t94}</td>;
    $[200] = t94;
    $[201] = t95;
  } else {
    t95 = $[201];
  }
  let t96;
  if ($[202] !== t) {
    t96 = t("seoPaymentGateway:sections.4.subsections.2.table.rows.1.columns.3");
    $[202] = t;
    $[203] = t96;
  } else {
    t96 = $[203];
  }
  let t97;
  if ($[204] !== t96) {
    t97 = <td colSpan={2} className="w-64 text-left!">{t96}</td>;
    $[204] = t96;
    $[205] = t97;
  } else {
    t97 = $[205];
  }
  let t98;
  if ($[206] !== t93 || $[207] !== t95 || $[208] !== t97) {
    t98 = <tr>{t93}{t95}{t97}</tr>;
    $[206] = t93;
    $[207] = t95;
    $[208] = t97;
    $[209] = t98;
  } else {
    t98 = $[209];
  }
  let t99;
  if ($[210] !== t91 || $[211] !== t98) {
    t99 = <Table head={t91} body={t98} className="mt-8 mb-16" />;
    $[210] = t91;
    $[211] = t98;
    $[212] = t99;
  } else {
    t99 = $[212];
  }
  let t100;
  if ($[213] !== t76 || $[214] !== t78 || $[215] !== t80 || $[216] !== t82 || $[217] !== t84 || $[218] !== t99) {
    t100 = <>{t76}{t78}{t80}{t82}{t84}{t99}</>;
    $[213] = t76;
    $[214] = t78;
    $[215] = t80;
    $[216] = t82;
    $[217] = t84;
    $[218] = t99;
    $[219] = t100;
  } else {
    t100 = $[219];
  }
  let t101;
  if ($[220] !== t100 || $[221] !== t74) {
    t101 = {
      title: t74,
      content: t100
    };
    $[220] = t100;
    $[221] = t74;
    $[222] = t101;
  } else {
    t101 = $[222];
  }
  let t102;
  if ($[223] !== t) {
    t102 = t("seoPaymentGateway:sections.4.subsections.3.title");
    $[223] = t;
    $[224] = t102;
  } else {
    t102 = $[224];
  }
  let t103;
  if ($[225] === Symbol.for("react.memo_cache_sentinel")) {
    t103 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[225] = t103;
  } else {
    t103 = $[225];
  }
  let t104;
  if ($[226] !== t) {
    t104 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.3.content1" components={t103} />;
    $[226] = t;
    $[227] = t104;
  } else {
    t104 = $[227];
  }
  let t105;
  if ($[228] === Symbol.for("react.memo_cache_sentinel")) {
    t105 = {
      minorheader: <MinorHeader />,
      paragraph: <Paragraph />
    };
    $[228] = t105;
  } else {
    t105 = $[228];
  }
  let t106;
  if ($[229] !== t) {
    t106 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.3.content2" components={t105} />;
    $[229] = t;
    $[230] = t106;
  } else {
    t106 = $[230];
  }
  let t107;
  if ($[231] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = {
      minorheader: <MinorHeader />
    };
    $[231] = t107;
  } else {
    t107 = $[231];
  }
  let t108;
  if ($[232] !== t) {
    t108 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.3.subtitle1" components={t107} />;
    $[232] = t;
    $[233] = t108;
  } else {
    t108 = $[233];
  }
  let t109;
  if ($[234] === Symbol.for("react.memo_cache_sentinel")) {
    t109 = [...Array(6)];
    $[234] = t109;
  } else {
    t109 = $[234];
  }
  let t110;
  if ($[235] !== t) {
    t110 = <PropsConsList items={t109.map((__1, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 6>;
      return <Trans key={i_1} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.3.props.${transIndex_1}`} />;
    })} variant="props" />;
    $[235] = t;
    $[236] = t110;
  } else {
    t110 = $[236];
  }
  let t111;
  if ($[237] === Symbol.for("react.memo_cache_sentinel")) {
    t111 = {
      minorheader: <MinorHeader />
    };
    $[237] = t111;
  } else {
    t111 = $[237];
  }
  let t112;
  if ($[238] !== t) {
    t112 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.3.subtitle2" components={t111} />;
    $[238] = t;
    $[239] = t112;
  } else {
    t112 = $[239];
  }
  let t113;
  if ($[240] !== t) {
    t113 = t("seoPaymentGateway:sections.4.subsections.3.cons");
    $[240] = t;
    $[241] = t113;
  } else {
    t113 = $[241];
  }
  let t114;
  if ($[242] !== t113) {
    t114 = <PropsConsList items={[t113]} variant="cons" />;
    $[242] = t113;
    $[243] = t114;
  } else {
    t114 = $[243];
  }
  let t115;
  if ($[244] !== t) {
    t115 = t("seoPaymentGateway:sections.4.subsections.3.table.headers.1");
    $[244] = t;
    $[245] = t115;
  } else {
    t115 = $[245];
  }
  let t116;
  if ($[246] !== t115) {
    t116 = <th className="w-56 rounded-tr-none!">{t115}</th>;
    $[246] = t115;
    $[247] = t116;
  } else {
    t116 = $[247];
  }
  let t117;
  if ($[248] !== t) {
    t117 = t("seoPaymentGateway:sections.4.subsections.3.table.headers.2");
    $[248] = t;
    $[249] = t117;
  } else {
    t117 = $[249];
  }
  let t118;
  if ($[250] !== t117) {
    t118 = <th colSpan={2} className="w-64">{t117}</th>;
    $[250] = t117;
    $[251] = t118;
  } else {
    t118 = $[251];
  }
  let t119;
  if ($[252] !== t) {
    t119 = t("seoPaymentGateway:sections.4.subsections.3.table.headers.3");
    $[252] = t;
    $[253] = t119;
  } else {
    t119 = $[253];
  }
  let t120;
  if ($[254] !== t119) {
    t120 = <th colSpan={2} className="w-64 rounded-tr-md">{t119}</th>;
    $[254] = t119;
    $[255] = t120;
  } else {
    t120 = $[255];
  }
  let t121;
  if ($[256] !== t116 || $[257] !== t118 || $[258] !== t120) {
    t121 = <tr>{t116}{t118}{t120}</tr>;
    $[256] = t116;
    $[257] = t118;
    $[258] = t120;
    $[259] = t121;
  } else {
    t121 = $[259];
  }
  let t122;
  if ($[260] !== t) {
    t122 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.1.columns.1");
    $[260] = t;
    $[261] = t122;
  } else {
    t122 = $[261];
  }
  let t123;
  if ($[262] !== t122) {
    t123 = <td className="w-56">{t122}</td>;
    $[262] = t122;
    $[263] = t123;
  } else {
    t123 = $[263];
  }
  let t124;
  if ($[264] !== t) {
    t124 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.1.columns.2");
    $[264] = t;
    $[265] = t124;
  } else {
    t124 = $[265];
  }
  let t125;
  if ($[266] !== t124) {
    t125 = <td colSpan={2} className="w-64 text-left!">{t124}</td>;
    $[266] = t124;
    $[267] = t125;
  } else {
    t125 = $[267];
  }
  let t126;
  if ($[268] !== t) {
    t126 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.1.columns.3");
    $[268] = t;
    $[269] = t126;
  } else {
    t126 = $[269];
  }
  let t127;
  if ($[270] !== t126) {
    t127 = <td colSpan={2} className="w-64 text-left!">{t126}</td>;
    $[270] = t126;
    $[271] = t127;
  } else {
    t127 = $[271];
  }
  let t128;
  if ($[272] !== t123 || $[273] !== t125 || $[274] !== t127) {
    t128 = <tr>{t123}{t125}{t127}</tr>;
    $[272] = t123;
    $[273] = t125;
    $[274] = t127;
    $[275] = t128;
  } else {
    t128 = $[275];
  }
  let t129;
  if ($[276] !== t) {
    t129 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.2.columns.1");
    $[276] = t;
    $[277] = t129;
  } else {
    t129 = $[277];
  }
  let t130;
  if ($[278] !== t129) {
    t130 = <td>{t129}</td>;
    $[278] = t129;
    $[279] = t130;
  } else {
    t130 = $[279];
  }
  let t131;
  if ($[280] !== t) {
    t131 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.2.columns.2");
    $[280] = t;
    $[281] = t131;
  } else {
    t131 = $[281];
  }
  let t132;
  if ($[282] !== t131) {
    t132 = <td colSpan={2} className="w-64 text-left!">{t131}</td>;
    $[282] = t131;
    $[283] = t132;
  } else {
    t132 = $[283];
  }
  let t133;
  if ($[284] !== t) {
    t133 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.2.columns.3");
    $[284] = t;
    $[285] = t133;
  } else {
    t133 = $[285];
  }
  let t134;
  if ($[286] !== t133) {
    t134 = <td colSpan={2} className="w-64 text-left!">{t133}</td>;
    $[286] = t133;
    $[287] = t134;
  } else {
    t134 = $[287];
  }
  let t135;
  if ($[288] !== t130 || $[289] !== t132 || $[290] !== t134) {
    t135 = <tr>{t130}{t132}{t134}</tr>;
    $[288] = t130;
    $[289] = t132;
    $[290] = t134;
    $[291] = t135;
  } else {
    t135 = $[291];
  }
  let t136;
  if ($[292] !== t) {
    t136 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.3.columns.1");
    $[292] = t;
    $[293] = t136;
  } else {
    t136 = $[293];
  }
  let t137;
  if ($[294] !== t136) {
    t137 = <td className="w-56">{t136}</td>;
    $[294] = t136;
    $[295] = t137;
  } else {
    t137 = $[295];
  }
  let t138;
  if ($[296] !== t) {
    t138 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.3.columns.2");
    $[296] = t;
    $[297] = t138;
  } else {
    t138 = $[297];
  }
  let t139;
  if ($[298] !== t138) {
    t139 = <td colSpan={2} className="w-64 text-left!">{t138}</td>;
    $[298] = t138;
    $[299] = t139;
  } else {
    t139 = $[299];
  }
  let t140;
  if ($[300] !== t) {
    t140 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.3.columns.3");
    $[300] = t;
    $[301] = t140;
  } else {
    t140 = $[301];
  }
  let t141;
  if ($[302] !== t140) {
    t141 = <td colSpan={2} className="w-64 text-left!">{t140}</td>;
    $[302] = t140;
    $[303] = t141;
  } else {
    t141 = $[303];
  }
  let t142;
  if ($[304] !== t137 || $[305] !== t139 || $[306] !== t141) {
    t142 = <tr>{t137}{t139}{t141}</tr>;
    $[304] = t137;
    $[305] = t139;
    $[306] = t141;
    $[307] = t142;
  } else {
    t142 = $[307];
  }
  let t143;
  if ($[308] !== t) {
    t143 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.4.columns.1");
    $[308] = t;
    $[309] = t143;
  } else {
    t143 = $[309];
  }
  let t144;
  if ($[310] !== t143) {
    t144 = <td className="w-56">{t143}</td>;
    $[310] = t143;
    $[311] = t144;
  } else {
    t144 = $[311];
  }
  let t145;
  if ($[312] !== t) {
    t145 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.4.columns.2");
    $[312] = t;
    $[313] = t145;
  } else {
    t145 = $[313];
  }
  let t146;
  if ($[314] !== t145) {
    t146 = <td colSpan={2} className="w-64 text-left!">{t145}</td>;
    $[314] = t145;
    $[315] = t146;
  } else {
    t146 = $[315];
  }
  let t147;
  if ($[316] !== t) {
    t147 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.4.columns.3");
    $[316] = t;
    $[317] = t147;
  } else {
    t147 = $[317];
  }
  let t148;
  if ($[318] !== t147) {
    t148 = <td colSpan={2} className="w-64 text-left!">{t147}</td>;
    $[318] = t147;
    $[319] = t148;
  } else {
    t148 = $[319];
  }
  let t149;
  if ($[320] !== t144 || $[321] !== t146 || $[322] !== t148) {
    t149 = <tr>{t144}{t146}{t148}</tr>;
    $[320] = t144;
    $[321] = t146;
    $[322] = t148;
    $[323] = t149;
  } else {
    t149 = $[323];
  }
  let t150;
  if ($[324] !== t) {
    t150 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.5.columns.1");
    $[324] = t;
    $[325] = t150;
  } else {
    t150 = $[325];
  }
  let t151;
  if ($[326] !== t150) {
    t151 = <td className="w-56">{t150}</td>;
    $[326] = t150;
    $[327] = t151;
  } else {
    t151 = $[327];
  }
  let t152;
  if ($[328] !== t) {
    t152 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.5.columns.2");
    $[328] = t;
    $[329] = t152;
  } else {
    t152 = $[329];
  }
  let t153;
  if ($[330] !== t152) {
    t153 = <td colSpan={2} className="w-64 text-left!">{t152}</td>;
    $[330] = t152;
    $[331] = t153;
  } else {
    t153 = $[331];
  }
  let t154;
  if ($[332] !== t) {
    t154 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.5.columns.3");
    $[332] = t;
    $[333] = t154;
  } else {
    t154 = $[333];
  }
  let t155;
  if ($[334] !== t154) {
    t155 = <td colSpan={2} className="w-64 text-left!">{t154}</td>;
    $[334] = t154;
    $[335] = t155;
  } else {
    t155 = $[335];
  }
  let t156;
  if ($[336] !== t151 || $[337] !== t153 || $[338] !== t155) {
    t156 = <tr>{t151}{t153}{t155}</tr>;
    $[336] = t151;
    $[337] = t153;
    $[338] = t155;
    $[339] = t156;
  } else {
    t156 = $[339];
  }
  let t157;
  if ($[340] !== t) {
    t157 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.6.columns.1");
    $[340] = t;
    $[341] = t157;
  } else {
    t157 = $[341];
  }
  let t158;
  if ($[342] !== t157) {
    t158 = <td className="w-56">{t157}</td>;
    $[342] = t157;
    $[343] = t158;
  } else {
    t158 = $[343];
  }
  let t159;
  if ($[344] !== t) {
    t159 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.6.columns.2");
    $[344] = t;
    $[345] = t159;
  } else {
    t159 = $[345];
  }
  let t160;
  if ($[346] !== t159) {
    t160 = <td colSpan={2} className="w-64 text-left!">{t159}</td>;
    $[346] = t159;
    $[347] = t160;
  } else {
    t160 = $[347];
  }
  let t161;
  if ($[348] !== t) {
    t161 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.6.columns.3");
    $[348] = t;
    $[349] = t161;
  } else {
    t161 = $[349];
  }
  let t162;
  if ($[350] !== t161) {
    t162 = <td colSpan={2} className="w-64 text-left!">{t161}</td>;
    $[350] = t161;
    $[351] = t162;
  } else {
    t162 = $[351];
  }
  let t163;
  if ($[352] !== t158 || $[353] !== t160 || $[354] !== t162) {
    t163 = <tr>{t158}{t160}{t162}</tr>;
    $[352] = t158;
    $[353] = t160;
    $[354] = t162;
    $[355] = t163;
  } else {
    t163 = $[355];
  }
  let t164;
  if ($[356] !== t) {
    t164 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.7.columns.1");
    $[356] = t;
    $[357] = t164;
  } else {
    t164 = $[357];
  }
  let t165;
  if ($[358] !== t164) {
    t165 = <td className="w-56">{t164}</td>;
    $[358] = t164;
    $[359] = t165;
  } else {
    t165 = $[359];
  }
  let t166;
  if ($[360] !== t) {
    t166 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.7.columns.2");
    $[360] = t;
    $[361] = t166;
  } else {
    t166 = $[361];
  }
  let t167;
  if ($[362] !== t166) {
    t167 = <td colSpan={2} className="w-64 text-left!">{t166}</td>;
    $[362] = t166;
    $[363] = t167;
  } else {
    t167 = $[363];
  }
  let t168;
  if ($[364] !== t) {
    t168 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.7.columns.3");
    $[364] = t;
    $[365] = t168;
  } else {
    t168 = $[365];
  }
  let t169;
  if ($[366] !== t168) {
    t169 = <td colSpan={2} className="w-64 text-left!">{t168}</td>;
    $[366] = t168;
    $[367] = t169;
  } else {
    t169 = $[367];
  }
  let t170;
  if ($[368] !== t165 || $[369] !== t167 || $[370] !== t169) {
    t170 = <tr>{t165}{t167}{t169}</tr>;
    $[368] = t165;
    $[369] = t167;
    $[370] = t169;
    $[371] = t170;
  } else {
    t170 = $[371];
  }
  let t171;
  if ($[372] !== t) {
    t171 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.8.columns.1");
    $[372] = t;
    $[373] = t171;
  } else {
    t171 = $[373];
  }
  let t172;
  if ($[374] !== t171) {
    t172 = <td className="w-56">{t171}</td>;
    $[374] = t171;
    $[375] = t172;
  } else {
    t172 = $[375];
  }
  let t173;
  if ($[376] !== t) {
    t173 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.8.columns.2");
    $[376] = t;
    $[377] = t173;
  } else {
    t173 = $[377];
  }
  let t174;
  if ($[378] !== t173) {
    t174 = <td colSpan={2} className="w-64 text-left!">{t173}</td>;
    $[378] = t173;
    $[379] = t174;
  } else {
    t174 = $[379];
  }
  let t175;
  if ($[380] !== t) {
    t175 = t("seoPaymentGateway:sections.4.subsections.3.table.rows.8.columns.3");
    $[380] = t;
    $[381] = t175;
  } else {
    t175 = $[381];
  }
  let t176;
  if ($[382] !== t175) {
    t176 = <td colSpan={2} className="w-64 text-left!">{t175}</td>;
    $[382] = t175;
    $[383] = t176;
  } else {
    t176 = $[383];
  }
  let t177;
  if ($[384] !== t172 || $[385] !== t174 || $[386] !== t176) {
    t177 = <tr>{t172}{t174}{t176}</tr>;
    $[384] = t172;
    $[385] = t174;
    $[386] = t176;
    $[387] = t177;
  } else {
    t177 = $[387];
  }
  let t178;
  if ($[388] !== t128 || $[389] !== t135 || $[390] !== t142 || $[391] !== t149 || $[392] !== t156 || $[393] !== t163 || $[394] !== t170 || $[395] !== t177) {
    t178 = <>{t128}{t135}{t142}{t149}{t156}{t163}{t170}{t177}</>;
    $[388] = t128;
    $[389] = t135;
    $[390] = t142;
    $[391] = t149;
    $[392] = t156;
    $[393] = t163;
    $[394] = t170;
    $[395] = t177;
    $[396] = t178;
  } else {
    t178 = $[396];
  }
  let t179;
  if ($[397] !== t121 || $[398] !== t178) {
    t179 = <Table head={t121} body={t178} className="mt-8 mb-16" />;
    $[397] = t121;
    $[398] = t178;
    $[399] = t179;
  } else {
    t179 = $[399];
  }
  let t180;
  if ($[400] !== t104 || $[401] !== t106 || $[402] !== t108 || $[403] !== t110 || $[404] !== t112 || $[405] !== t114 || $[406] !== t179) {
    t180 = <>{t104}{t106}{t108}{t110}{t112}{t114}{t179}</>;
    $[400] = t104;
    $[401] = t106;
    $[402] = t108;
    $[403] = t110;
    $[404] = t112;
    $[405] = t114;
    $[406] = t179;
    $[407] = t180;
  } else {
    t180 = $[407];
  }
  let t181;
  if ($[408] !== t102 || $[409] !== t180) {
    t181 = {
      title: t102,
      content: t180
    };
    $[408] = t102;
    $[409] = t180;
    $[410] = t181;
  } else {
    t181 = $[410];
  }
  let t182;
  if ($[411] !== t) {
    t182 = t("seoPaymentGateway:sections.4.subsections.4.title");
    $[411] = t;
    $[412] = t182;
  } else {
    t182 = $[412];
  }
  let t183;
  if ($[413] === Symbol.for("react.memo_cache_sentinel")) {
    t183 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[413] = t183;
  } else {
    t183 = $[413];
  }
  let t184;
  if ($[414] !== t) {
    t184 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.4.content" components={t183} />;
    $[414] = t;
    $[415] = t184;
  } else {
    t184 = $[415];
  }
  let t185;
  if ($[416] === Symbol.for("react.memo_cache_sentinel")) {
    t185 = {
      minorheader: <MinorHeader />
    };
    $[416] = t185;
  } else {
    t185 = $[416];
  }
  let t186;
  if ($[417] !== t) {
    t186 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.4.subtitle1" components={t185} />;
    $[417] = t;
    $[418] = t186;
  } else {
    t186 = $[418];
  }
  let t187;
  if ($[419] === Symbol.for("react.memo_cache_sentinel")) {
    t187 = [...Array(4)];
    $[419] = t187;
  } else {
    t187 = $[419];
  }
  let t188;
  if ($[420] !== t) {
    t188 = <PropsConsList items={t187.map((__2, i_2) => {
      const transIndex_2 = i_2 + 1 as NumericRange<1, 4>;
      return <Trans key={i_2} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.4.props.${transIndex_2}`} />;
    })} variant="props" />;
    $[420] = t;
    $[421] = t188;
  } else {
    t188 = $[421];
  }
  let t189;
  if ($[422] === Symbol.for("react.memo_cache_sentinel")) {
    t189 = {
      minorheader: <MinorHeader />
    };
    $[422] = t189;
  } else {
    t189 = $[422];
  }
  let t190;
  if ($[423] !== t) {
    t190 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.4.subtitle2" components={t189} />;
    $[423] = t;
    $[424] = t190;
  } else {
    t190 = $[424];
  }
  let t191;
  if ($[425] !== t) {
    t191 = t("seoPaymentGateway:sections.4.subsections.4.cons");
    $[425] = t;
    $[426] = t191;
  } else {
    t191 = $[426];
  }
  let t192;
  if ($[427] !== t191) {
    t192 = <PropsConsList items={[t191]} variant="cons" />;
    $[427] = t191;
    $[428] = t192;
  } else {
    t192 = $[428];
  }
  let t193;
  if ($[429] !== t) {
    t193 = t("seoPaymentGateway:sections.4.subsections.4.table.headers.1");
    $[429] = t;
    $[430] = t193;
  } else {
    t193 = $[430];
  }
  let t194;
  if ($[431] !== t193) {
    t194 = <th className="w-56 rounded-tr-none!">{t193}</th>;
    $[431] = t193;
    $[432] = t194;
  } else {
    t194 = $[432];
  }
  let t195;
  if ($[433] !== t) {
    t195 = t("seoPaymentGateway:sections.4.subsections.4.table.headers.2");
    $[433] = t;
    $[434] = t195;
  } else {
    t195 = $[434];
  }
  let t196;
  if ($[435] !== t195) {
    t196 = <th className="w-72">{t195}</th>;
    $[435] = t195;
    $[436] = t196;
  } else {
    t196 = $[436];
  }
  let t197;
  if ($[437] !== t) {
    t197 = t("seoPaymentGateway:sections.4.subsections.4.table.headers.3");
    $[437] = t;
    $[438] = t197;
  } else {
    t197 = $[438];
  }
  let t198;
  if ($[439] !== t197) {
    t198 = <th className="w-32">{t197}</th>;
    $[439] = t197;
    $[440] = t198;
  } else {
    t198 = $[440];
  }
  let t199;
  if ($[441] !== t) {
    t199 = t("seoPaymentGateway:sections.4.subsections.4.table.headers.4");
    $[441] = t;
    $[442] = t199;
  } else {
    t199 = $[442];
  }
  let t200;
  if ($[443] !== t199) {
    t200 = <th className="w-32 rounded-tr-md">{t199}</th>;
    $[443] = t199;
    $[444] = t200;
  } else {
    t200 = $[444];
  }
  let t201;
  if ($[445] !== t194 || $[446] !== t196 || $[447] !== t198 || $[448] !== t200) {
    t201 = <tr>{t194}{t196}{t198}{t200}</tr>;
    $[445] = t194;
    $[446] = t196;
    $[447] = t198;
    $[448] = t200;
    $[449] = t201;
  } else {
    t201 = $[449];
  }
  let t202;
  if ($[450] !== t) {
    t202 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.1.columns.1");
    $[450] = t;
    $[451] = t202;
  } else {
    t202 = $[451];
  }
  let t203;
  if ($[452] !== t202) {
    t203 = <td className="w-56">{t202}</td>;
    $[452] = t202;
    $[453] = t203;
  } else {
    t203 = $[453];
  }
  let t204;
  if ($[454] !== t) {
    t204 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.1.columns.2");
    $[454] = t;
    $[455] = t204;
  } else {
    t204 = $[455];
  }
  let t205;
  if ($[456] !== t204) {
    t205 = <td className="w-72 text-left!">{t204}</td>;
    $[456] = t204;
    $[457] = t205;
  } else {
    t205 = $[457];
  }
  let t206;
  if ($[458] !== t) {
    t206 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.1.columns.3");
    $[458] = t;
    $[459] = t206;
  } else {
    t206 = $[459];
  }
  let t207;
  if ($[460] !== t206) {
    t207 = <td className="w-32 text-left!">{t206}</td>;
    $[460] = t206;
    $[461] = t207;
  } else {
    t207 = $[461];
  }
  let t208;
  if ($[462] !== t) {
    t208 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.1.columns.4");
    $[462] = t;
    $[463] = t208;
  } else {
    t208 = $[463];
  }
  let t209;
  if ($[464] !== t208) {
    t209 = <td className="w-32 text-left!">{t208}</td>;
    $[464] = t208;
    $[465] = t209;
  } else {
    t209 = $[465];
  }
  let t210;
  if ($[466] !== t203 || $[467] !== t205 || $[468] !== t207 || $[469] !== t209) {
    t210 = <tr>{t203}{t205}{t207}{t209}</tr>;
    $[466] = t203;
    $[467] = t205;
    $[468] = t207;
    $[469] = t209;
    $[470] = t210;
  } else {
    t210 = $[470];
  }
  let t211;
  if ($[471] !== t) {
    t211 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.2.columns.1");
    $[471] = t;
    $[472] = t211;
  } else {
    t211 = $[472];
  }
  let t212;
  if ($[473] !== t211) {
    t212 = <td className="w-56">{t211}</td>;
    $[473] = t211;
    $[474] = t212;
  } else {
    t212 = $[474];
  }
  let t213;
  if ($[475] !== t) {
    t213 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.2.columns.2");
    $[475] = t;
    $[476] = t213;
  } else {
    t213 = $[476];
  }
  let t214;
  if ($[477] !== t213) {
    t214 = <td className="w-72 text-left!">{t213}</td>;
    $[477] = t213;
    $[478] = t214;
  } else {
    t214 = $[478];
  }
  let t215;
  if ($[479] !== t) {
    t215 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.2.columns.3");
    $[479] = t;
    $[480] = t215;
  } else {
    t215 = $[480];
  }
  let t216;
  if ($[481] !== t215) {
    t216 = <td className="w-32 text-left!">{t215}</td>;
    $[481] = t215;
    $[482] = t216;
  } else {
    t216 = $[482];
  }
  let t217;
  if ($[483] !== t) {
    t217 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.2.columns.4");
    $[483] = t;
    $[484] = t217;
  } else {
    t217 = $[484];
  }
  let t218;
  if ($[485] !== t217) {
    t218 = <td className="w-32 text-left!">{t217}</td>;
    $[485] = t217;
    $[486] = t218;
  } else {
    t218 = $[486];
  }
  let t219;
  if ($[487] !== t212 || $[488] !== t214 || $[489] !== t216 || $[490] !== t218) {
    t219 = <tr>{t212}{t214}{t216}{t218}</tr>;
    $[487] = t212;
    $[488] = t214;
    $[489] = t216;
    $[490] = t218;
    $[491] = t219;
  } else {
    t219 = $[491];
  }
  let t220;
  if ($[492] !== t) {
    t220 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.3.columns.1");
    $[492] = t;
    $[493] = t220;
  } else {
    t220 = $[493];
  }
  let t221;
  if ($[494] !== t220) {
    t221 = <td className="w-56">{t220}</td>;
    $[494] = t220;
    $[495] = t221;
  } else {
    t221 = $[495];
  }
  let t222;
  if ($[496] !== t) {
    t222 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.3.columns.2");
    $[496] = t;
    $[497] = t222;
  } else {
    t222 = $[497];
  }
  let t223;
  if ($[498] !== t222) {
    t223 = <td className="w-72 text-left!">{t222}</td>;
    $[498] = t222;
    $[499] = t223;
  } else {
    t223 = $[499];
  }
  let t224;
  if ($[500] !== t) {
    t224 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.3.columns.3");
    $[500] = t;
    $[501] = t224;
  } else {
    t224 = $[501];
  }
  let t225;
  if ($[502] !== t224) {
    t225 = <td className="w-32 text-left!">{t224}</td>;
    $[502] = t224;
    $[503] = t225;
  } else {
    t225 = $[503];
  }
  let t226;
  if ($[504] !== t) {
    t226 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.3.columns.4");
    $[504] = t;
    $[505] = t226;
  } else {
    t226 = $[505];
  }
  let t227;
  if ($[506] !== t226) {
    t227 = <td className="w-32 text-left!">{t226}</td>;
    $[506] = t226;
    $[507] = t227;
  } else {
    t227 = $[507];
  }
  let t228;
  if ($[508] !== t221 || $[509] !== t223 || $[510] !== t225 || $[511] !== t227) {
    t228 = <tr>{t221}{t223}{t225}{t227}</tr>;
    $[508] = t221;
    $[509] = t223;
    $[510] = t225;
    $[511] = t227;
    $[512] = t228;
  } else {
    t228 = $[512];
  }
  let t229;
  if ($[513] !== t) {
    t229 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.4.columns.1");
    $[513] = t;
    $[514] = t229;
  } else {
    t229 = $[514];
  }
  let t230;
  if ($[515] !== t229) {
    t230 = <td className="w-56">{t229}</td>;
    $[515] = t229;
    $[516] = t230;
  } else {
    t230 = $[516];
  }
  let t231;
  if ($[517] !== t) {
    t231 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.4.columns.2");
    $[517] = t;
    $[518] = t231;
  } else {
    t231 = $[518];
  }
  let t232;
  if ($[519] !== t231) {
    t232 = <td className="w-72 text-left!">{t231}</td>;
    $[519] = t231;
    $[520] = t232;
  } else {
    t232 = $[520];
  }
  let t233;
  if ($[521] !== t) {
    t233 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.4.columns.3");
    $[521] = t;
    $[522] = t233;
  } else {
    t233 = $[522];
  }
  let t234;
  if ($[523] !== t233) {
    t234 = <td className="w-32 text-left!">{t233}</td>;
    $[523] = t233;
    $[524] = t234;
  } else {
    t234 = $[524];
  }
  let t235;
  if ($[525] !== t) {
    t235 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.4.columns.4");
    $[525] = t;
    $[526] = t235;
  } else {
    t235 = $[526];
  }
  let t236;
  if ($[527] !== t235) {
    t236 = <td className="w-32 text-left!">{t235}</td>;
    $[527] = t235;
    $[528] = t236;
  } else {
    t236 = $[528];
  }
  let t237;
  if ($[529] !== t230 || $[530] !== t232 || $[531] !== t234 || $[532] !== t236) {
    t237 = <tr>{t230}{t232}{t234}{t236}</tr>;
    $[529] = t230;
    $[530] = t232;
    $[531] = t234;
    $[532] = t236;
    $[533] = t237;
  } else {
    t237 = $[533];
  }
  let t238;
  if ($[534] !== t) {
    t238 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.5.columns.1");
    $[534] = t;
    $[535] = t238;
  } else {
    t238 = $[535];
  }
  let t239;
  if ($[536] !== t238) {
    t239 = <td className="w-56">{t238}</td>;
    $[536] = t238;
    $[537] = t239;
  } else {
    t239 = $[537];
  }
  let t240;
  if ($[538] !== t) {
    t240 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.5.columns.2");
    $[538] = t;
    $[539] = t240;
  } else {
    t240 = $[539];
  }
  let t241;
  if ($[540] !== t240) {
    t241 = <td className="w-72 text-left!">{t240}</td>;
    $[540] = t240;
    $[541] = t241;
  } else {
    t241 = $[541];
  }
  let t242;
  if ($[542] !== t) {
    t242 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.5.columns.3");
    $[542] = t;
    $[543] = t242;
  } else {
    t242 = $[543];
  }
  let t243;
  if ($[544] !== t242) {
    t243 = <td className="w-32 text-left!">{t242}</td>;
    $[544] = t242;
    $[545] = t243;
  } else {
    t243 = $[545];
  }
  let t244;
  if ($[546] !== t) {
    t244 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.5.columns.4");
    $[546] = t;
    $[547] = t244;
  } else {
    t244 = $[547];
  }
  let t245;
  if ($[548] !== t244) {
    t245 = <td className="w-32 text-left!">{t244}</td>;
    $[548] = t244;
    $[549] = t245;
  } else {
    t245 = $[549];
  }
  let t246;
  if ($[550] !== t239 || $[551] !== t241 || $[552] !== t243 || $[553] !== t245) {
    t246 = <tr>{t239}{t241}{t243}{t245}</tr>;
    $[550] = t239;
    $[551] = t241;
    $[552] = t243;
    $[553] = t245;
    $[554] = t246;
  } else {
    t246 = $[554];
  }
  let t247;
  if ($[555] !== t) {
    t247 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.6.columns.1");
    $[555] = t;
    $[556] = t247;
  } else {
    t247 = $[556];
  }
  let t248;
  if ($[557] !== t247) {
    t248 = <td className="w-56">{t247}</td>;
    $[557] = t247;
    $[558] = t248;
  } else {
    t248 = $[558];
  }
  let t249;
  if ($[559] !== t) {
    t249 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.6.columns.2");
    $[559] = t;
    $[560] = t249;
  } else {
    t249 = $[560];
  }
  let t250;
  if ($[561] !== t249) {
    t250 = <td className="w-72 text-left!">{t249}</td>;
    $[561] = t249;
    $[562] = t250;
  } else {
    t250 = $[562];
  }
  let t251;
  if ($[563] !== t) {
    t251 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.6.columns.3");
    $[563] = t;
    $[564] = t251;
  } else {
    t251 = $[564];
  }
  let t252;
  if ($[565] !== t251) {
    t252 = <td className="w-32 text-left!">{t251}</td>;
    $[565] = t251;
    $[566] = t252;
  } else {
    t252 = $[566];
  }
  let t253;
  if ($[567] !== t) {
    t253 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.6.columns.4");
    $[567] = t;
    $[568] = t253;
  } else {
    t253 = $[568];
  }
  let t254;
  if ($[569] !== t253) {
    t254 = <td className="w-32 text-left!">{t253}</td>;
    $[569] = t253;
    $[570] = t254;
  } else {
    t254 = $[570];
  }
  let t255;
  if ($[571] !== t248 || $[572] !== t250 || $[573] !== t252 || $[574] !== t254) {
    t255 = <tr>{t248}{t250}{t252}{t254}</tr>;
    $[571] = t248;
    $[572] = t250;
    $[573] = t252;
    $[574] = t254;
    $[575] = t255;
  } else {
    t255 = $[575];
  }
  let t256;
  if ($[576] !== t) {
    t256 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.7.columns.1");
    $[576] = t;
    $[577] = t256;
  } else {
    t256 = $[577];
  }
  let t257;
  if ($[578] !== t256) {
    t257 = <td className="w-56">{t256}</td>;
    $[578] = t256;
    $[579] = t257;
  } else {
    t257 = $[579];
  }
  let t258;
  if ($[580] !== t) {
    t258 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.7.columns.2");
    $[580] = t;
    $[581] = t258;
  } else {
    t258 = $[581];
  }
  let t259;
  if ($[582] !== t258) {
    t259 = <td className="w-72 text-left!">{t258}</td>;
    $[582] = t258;
    $[583] = t259;
  } else {
    t259 = $[583];
  }
  let t260;
  if ($[584] !== t) {
    t260 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.7.columns.3");
    $[584] = t;
    $[585] = t260;
  } else {
    t260 = $[585];
  }
  let t261;
  if ($[586] !== t260) {
    t261 = <td className="w-32 text-left!">{t260}</td>;
    $[586] = t260;
    $[587] = t261;
  } else {
    t261 = $[587];
  }
  let t262;
  if ($[588] !== t) {
    t262 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.7.columns.4");
    $[588] = t;
    $[589] = t262;
  } else {
    t262 = $[589];
  }
  let t263;
  if ($[590] !== t262) {
    t263 = <td className="w-32 text-left!">{t262}</td>;
    $[590] = t262;
    $[591] = t263;
  } else {
    t263 = $[591];
  }
  let t264;
  if ($[592] !== t257 || $[593] !== t259 || $[594] !== t261 || $[595] !== t263) {
    t264 = <tr>{t257}{t259}{t261}{t263}</tr>;
    $[592] = t257;
    $[593] = t259;
    $[594] = t261;
    $[595] = t263;
    $[596] = t264;
  } else {
    t264 = $[596];
  }
  let t265;
  if ($[597] !== t) {
    t265 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.8.columns.1");
    $[597] = t;
    $[598] = t265;
  } else {
    t265 = $[598];
  }
  let t266;
  if ($[599] !== t265) {
    t266 = <td className="w-56">{t265}</td>;
    $[599] = t265;
    $[600] = t266;
  } else {
    t266 = $[600];
  }
  let t267;
  if ($[601] !== t) {
    t267 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.8.columns.2");
    $[601] = t;
    $[602] = t267;
  } else {
    t267 = $[602];
  }
  let t268;
  if ($[603] !== t267) {
    t268 = <td className="w-72 text-left!">{t267}</td>;
    $[603] = t267;
    $[604] = t268;
  } else {
    t268 = $[604];
  }
  let t269;
  if ($[605] !== t) {
    t269 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.8.columns.3");
    $[605] = t;
    $[606] = t269;
  } else {
    t269 = $[606];
  }
  let t270;
  if ($[607] !== t269) {
    t270 = <td className="w-32 text-left!">{t269}</td>;
    $[607] = t269;
    $[608] = t270;
  } else {
    t270 = $[608];
  }
  let t271;
  if ($[609] !== t) {
    t271 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.8.columns.4");
    $[609] = t;
    $[610] = t271;
  } else {
    t271 = $[610];
  }
  let t272;
  if ($[611] !== t271) {
    t272 = <td className="w-32 text-left!">{t271}</td>;
    $[611] = t271;
    $[612] = t272;
  } else {
    t272 = $[612];
  }
  let t273;
  if ($[613] !== t266 || $[614] !== t268 || $[615] !== t270 || $[616] !== t272) {
    t273 = <tr>{t266}{t268}{t270}{t272}</tr>;
    $[613] = t266;
    $[614] = t268;
    $[615] = t270;
    $[616] = t272;
    $[617] = t273;
  } else {
    t273 = $[617];
  }
  let t274;
  if ($[618] !== t) {
    t274 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.9.columns.1");
    $[618] = t;
    $[619] = t274;
  } else {
    t274 = $[619];
  }
  let t275;
  if ($[620] !== t274) {
    t275 = <td className="w-56">{t274}</td>;
    $[620] = t274;
    $[621] = t275;
  } else {
    t275 = $[621];
  }
  let t276;
  if ($[622] !== t) {
    t276 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.9.columns.2");
    $[622] = t;
    $[623] = t276;
  } else {
    t276 = $[623];
  }
  let t277;
  if ($[624] !== t276) {
    t277 = <td className="w-72 text-left!">{t276}</td>;
    $[624] = t276;
    $[625] = t277;
  } else {
    t277 = $[625];
  }
  let t278;
  if ($[626] !== t) {
    t278 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.9.columns.3");
    $[626] = t;
    $[627] = t278;
  } else {
    t278 = $[627];
  }
  let t279;
  if ($[628] !== t278) {
    t279 = <td className="w-32 text-left!">{t278}</td>;
    $[628] = t278;
    $[629] = t279;
  } else {
    t279 = $[629];
  }
  let t280;
  if ($[630] !== t) {
    t280 = t("seoPaymentGateway:sections.4.subsections.4.table.rows.9.columns.4");
    $[630] = t;
    $[631] = t280;
  } else {
    t280 = $[631];
  }
  let t281;
  if ($[632] !== t280) {
    t281 = <td className="w-32 text-left!">{t280}</td>;
    $[632] = t280;
    $[633] = t281;
  } else {
    t281 = $[633];
  }
  let t282;
  if ($[634] !== t275 || $[635] !== t277 || $[636] !== t279 || $[637] !== t281) {
    t282 = <tr>{t275}{t277}{t279}{t281}</tr>;
    $[634] = t275;
    $[635] = t277;
    $[636] = t279;
    $[637] = t281;
    $[638] = t282;
  } else {
    t282 = $[638];
  }
  let t283;
  if ($[639] !== t210 || $[640] !== t219 || $[641] !== t228 || $[642] !== t237 || $[643] !== t246 || $[644] !== t255 || $[645] !== t264 || $[646] !== t273 || $[647] !== t282) {
    t283 = <>{t210}{t219}{t228}{t237}{t246}{t255}{t264}{t273}{t282}</>;
    $[639] = t210;
    $[640] = t219;
    $[641] = t228;
    $[642] = t237;
    $[643] = t246;
    $[644] = t255;
    $[645] = t264;
    $[646] = t273;
    $[647] = t282;
    $[648] = t283;
  } else {
    t283 = $[648];
  }
  let t284;
  if ($[649] !== t201 || $[650] !== t283) {
    t284 = <Table head={t201} body={t283} className="mt-8 mb-16" />;
    $[649] = t201;
    $[650] = t283;
    $[651] = t284;
  } else {
    t284 = $[651];
  }
  let t285;
  if ($[652] !== t184 || $[653] !== t186 || $[654] !== t188 || $[655] !== t190 || $[656] !== t192 || $[657] !== t284) {
    t285 = <>{t184}{t186}{t188}{t190}{t192}{t284}</>;
    $[652] = t184;
    $[653] = t186;
    $[654] = t188;
    $[655] = t190;
    $[656] = t192;
    $[657] = t284;
    $[658] = t285;
  } else {
    t285 = $[658];
  }
  let t286;
  if ($[659] !== t182 || $[660] !== t285) {
    t286 = {
      title: t182,
      content: t285
    };
    $[659] = t182;
    $[660] = t285;
    $[661] = t286;
  } else {
    t286 = $[661];
  }
  let t287;
  if ($[662] !== t) {
    t287 = t("seoPaymentGateway:sections.4.subsections.5.title");
    $[662] = t;
    $[663] = t287;
  } else {
    t287 = $[663];
  }
  let t288;
  if ($[664] === Symbol.for("react.memo_cache_sentinel")) {
    t288 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[664] = t288;
  } else {
    t288 = $[664];
  }
  let t289;
  if ($[665] !== t) {
    t289 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.5.content" components={t288} />;
    $[665] = t;
    $[666] = t289;
  } else {
    t289 = $[666];
  }
  let t290;
  if ($[667] === Symbol.for("react.memo_cache_sentinel")) {
    t290 = {
      minorheader: <MinorHeader />
    };
    $[667] = t290;
  } else {
    t290 = $[667];
  }
  let t291;
  if ($[668] !== t) {
    t291 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.5.subtitle" components={t290} />;
    $[668] = t;
    $[669] = t291;
  } else {
    t291 = $[669];
  }
  let t292;
  if ($[670] === Symbol.for("react.memo_cache_sentinel")) {
    t292 = [...Array(5)];
    $[670] = t292;
  } else {
    t292 = $[670];
  }
  let t293;
  if ($[671] !== t) {
    t293 = <PropsConsList items={t292.map((__3, i_3) => {
      const transIndex_3 = i_3 + 1 as NumericRange<1, 5>;
      return <Trans key={i_3} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.5.props.${transIndex_3}`} />;
    })} variant="props" />;
    $[671] = t;
    $[672] = t293;
  } else {
    t293 = $[672];
  }
  let t294;
  if ($[673] !== t) {
    t294 = t("seoPaymentGateway:sections.4.subsections.5.table.headers.1");
    $[673] = t;
    $[674] = t294;
  } else {
    t294 = $[674];
  }
  let t295;
  if ($[675] !== t294) {
    t295 = <th className="w-56 rounded-tr-none!">{t294}</th>;
    $[675] = t294;
    $[676] = t295;
  } else {
    t295 = $[676];
  }
  let t296;
  if ($[677] !== t) {
    t296 = t("seoPaymentGateway:sections.4.subsections.5.table.headers.2");
    $[677] = t;
    $[678] = t296;
  } else {
    t296 = $[678];
  }
  let t297;
  if ($[679] !== t296) {
    t297 = <th colSpan={2} className="w-64">{t296}</th>;
    $[679] = t296;
    $[680] = t297;
  } else {
    t297 = $[680];
  }
  let t298;
  if ($[681] !== t) {
    t298 = t("seoPaymentGateway:sections.4.subsections.5.table.headers.3");
    $[681] = t;
    $[682] = t298;
  } else {
    t298 = $[682];
  }
  let t299;
  if ($[683] !== t298) {
    t299 = <th colSpan={2} className="w-64 rounded-tr-md">{t298}</th>;
    $[683] = t298;
    $[684] = t299;
  } else {
    t299 = $[684];
  }
  let t300;
  if ($[685] !== t295 || $[686] !== t297 || $[687] !== t299) {
    t300 = <tr>{t295}{t297}{t299}</tr>;
    $[685] = t295;
    $[686] = t297;
    $[687] = t299;
    $[688] = t300;
  } else {
    t300 = $[688];
  }
  let t301;
  if ($[689] !== t) {
    t301 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.1.columns.1");
    $[689] = t;
    $[690] = t301;
  } else {
    t301 = $[690];
  }
  let t302;
  if ($[691] !== t301) {
    t302 = <td className="w-56">{t301}</td>;
    $[691] = t301;
    $[692] = t302;
  } else {
    t302 = $[692];
  }
  let t303;
  if ($[693] !== t) {
    t303 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.1.columns.2");
    $[693] = t;
    $[694] = t303;
  } else {
    t303 = $[694];
  }
  let t304;
  if ($[695] !== t303) {
    t304 = <td colSpan={2} className="w-64 text-left!">{t303}</td>;
    $[695] = t303;
    $[696] = t304;
  } else {
    t304 = $[696];
  }
  let t305;
  if ($[697] !== t) {
    t305 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.1.columns.3");
    $[697] = t;
    $[698] = t305;
  } else {
    t305 = $[698];
  }
  let t306;
  if ($[699] !== t305) {
    t306 = <td colSpan={2} className="w-64 text-left!">{t305}</td>;
    $[699] = t305;
    $[700] = t306;
  } else {
    t306 = $[700];
  }
  let t307;
  if ($[701] !== t302 || $[702] !== t304 || $[703] !== t306) {
    t307 = <tr>{t302}{t304}{t306}</tr>;
    $[701] = t302;
    $[702] = t304;
    $[703] = t306;
    $[704] = t307;
  } else {
    t307 = $[704];
  }
  let t308;
  if ($[705] !== t) {
    t308 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.2.columns.1");
    $[705] = t;
    $[706] = t308;
  } else {
    t308 = $[706];
  }
  let t309;
  if ($[707] !== t308) {
    t309 = <td className="w-56">{t308}</td>;
    $[707] = t308;
    $[708] = t309;
  } else {
    t309 = $[708];
  }
  let t310;
  if ($[709] !== t) {
    t310 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.2.columns.2");
    $[709] = t;
    $[710] = t310;
  } else {
    t310 = $[710];
  }
  let t311;
  if ($[711] !== t310) {
    t311 = <td colSpan={2} className="w-64 text-left!">{t310}</td>;
    $[711] = t310;
    $[712] = t311;
  } else {
    t311 = $[712];
  }
  let t312;
  if ($[713] !== t) {
    t312 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.2.columns.3");
    $[713] = t;
    $[714] = t312;
  } else {
    t312 = $[714];
  }
  let t313;
  if ($[715] !== t312) {
    t313 = <td colSpan={2} className="w-64 text-left!">{t312}</td>;
    $[715] = t312;
    $[716] = t313;
  } else {
    t313 = $[716];
  }
  let t314;
  if ($[717] !== t309 || $[718] !== t311 || $[719] !== t313) {
    t314 = <tr>{t309}{t311}{t313}</tr>;
    $[717] = t309;
    $[718] = t311;
    $[719] = t313;
    $[720] = t314;
  } else {
    t314 = $[720];
  }
  let t315;
  if ($[721] !== t) {
    t315 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.3.columns.1");
    $[721] = t;
    $[722] = t315;
  } else {
    t315 = $[722];
  }
  let t316;
  if ($[723] !== t315) {
    t316 = <td className="w-56">{t315}</td>;
    $[723] = t315;
    $[724] = t316;
  } else {
    t316 = $[724];
  }
  let t317;
  if ($[725] !== t) {
    t317 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.3.columns.2");
    $[725] = t;
    $[726] = t317;
  } else {
    t317 = $[726];
  }
  let t318;
  if ($[727] !== t317) {
    t318 = <td colSpan={2} className="w-64 text-left!">{t317}</td>;
    $[727] = t317;
    $[728] = t318;
  } else {
    t318 = $[728];
  }
  let t319;
  if ($[729] !== t) {
    t319 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.3.columns.3");
    $[729] = t;
    $[730] = t319;
  } else {
    t319 = $[730];
  }
  let t320;
  if ($[731] !== t319) {
    t320 = <td colSpan={2} className="w-64 text-left!">{t319}</td>;
    $[731] = t319;
    $[732] = t320;
  } else {
    t320 = $[732];
  }
  let t321;
  if ($[733] !== t316 || $[734] !== t318 || $[735] !== t320) {
    t321 = <tr>{t316}{t318}{t320}</tr>;
    $[733] = t316;
    $[734] = t318;
    $[735] = t320;
    $[736] = t321;
  } else {
    t321 = $[736];
  }
  let t322;
  if ($[737] !== t) {
    t322 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.4.columns.1");
    $[737] = t;
    $[738] = t322;
  } else {
    t322 = $[738];
  }
  let t323;
  if ($[739] !== t322) {
    t323 = <td className="w-56">{t322}</td>;
    $[739] = t322;
    $[740] = t323;
  } else {
    t323 = $[740];
  }
  let t324;
  if ($[741] !== t) {
    t324 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.4.columns.2");
    $[741] = t;
    $[742] = t324;
  } else {
    t324 = $[742];
  }
  let t325;
  if ($[743] !== t324) {
    t325 = <td colSpan={2} className="w-64 text-left!">{t324}</td>;
    $[743] = t324;
    $[744] = t325;
  } else {
    t325 = $[744];
  }
  let t326;
  if ($[745] !== t) {
    t326 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.4.columns.3");
    $[745] = t;
    $[746] = t326;
  } else {
    t326 = $[746];
  }
  let t327;
  if ($[747] !== t326) {
    t327 = <td colSpan={2} className="w-64 text-left!">{t326}</td>;
    $[747] = t326;
    $[748] = t327;
  } else {
    t327 = $[748];
  }
  let t328;
  if ($[749] !== t323 || $[750] !== t325 || $[751] !== t327) {
    t328 = <tr>{t323}{t325}{t327}</tr>;
    $[749] = t323;
    $[750] = t325;
    $[751] = t327;
    $[752] = t328;
  } else {
    t328 = $[752];
  }
  let t329;
  if ($[753] !== t) {
    t329 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.5.columns.1");
    $[753] = t;
    $[754] = t329;
  } else {
    t329 = $[754];
  }
  let t330;
  if ($[755] !== t329) {
    t330 = <td className="w-56">{t329}</td>;
    $[755] = t329;
    $[756] = t330;
  } else {
    t330 = $[756];
  }
  let t331;
  if ($[757] !== t) {
    t331 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.5.columns.2");
    $[757] = t;
    $[758] = t331;
  } else {
    t331 = $[758];
  }
  let t332;
  if ($[759] !== t331) {
    t332 = <td colSpan={2} className="w-64 text-left!">{t331}</td>;
    $[759] = t331;
    $[760] = t332;
  } else {
    t332 = $[760];
  }
  let t333;
  if ($[761] !== t) {
    t333 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.5.columns.3");
    $[761] = t;
    $[762] = t333;
  } else {
    t333 = $[762];
  }
  let t334;
  if ($[763] !== t333) {
    t334 = <td colSpan={2} className="w-64 text-left!">{t333}</td>;
    $[763] = t333;
    $[764] = t334;
  } else {
    t334 = $[764];
  }
  let t335;
  if ($[765] !== t330 || $[766] !== t332 || $[767] !== t334) {
    t335 = <tr>{t330}{t332}{t334}</tr>;
    $[765] = t330;
    $[766] = t332;
    $[767] = t334;
    $[768] = t335;
  } else {
    t335 = $[768];
  }
  let t336;
  if ($[769] !== t) {
    t336 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.6.columns.1");
    $[769] = t;
    $[770] = t336;
  } else {
    t336 = $[770];
  }
  let t337;
  if ($[771] !== t336) {
    t337 = <td className="w-56">{t336}</td>;
    $[771] = t336;
    $[772] = t337;
  } else {
    t337 = $[772];
  }
  let t338;
  if ($[773] !== t) {
    t338 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.6.columns.2");
    $[773] = t;
    $[774] = t338;
  } else {
    t338 = $[774];
  }
  let t339;
  if ($[775] !== t338) {
    t339 = <td colSpan={2} className="w-64 text-left!">{t338}</td>;
    $[775] = t338;
    $[776] = t339;
  } else {
    t339 = $[776];
  }
  let t340;
  if ($[777] !== t) {
    t340 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.6.columns.3");
    $[777] = t;
    $[778] = t340;
  } else {
    t340 = $[778];
  }
  let t341;
  if ($[779] !== t340) {
    t341 = <td colSpan={2} className="w-64 text-left!">{t340}</td>;
    $[779] = t340;
    $[780] = t341;
  } else {
    t341 = $[780];
  }
  let t342;
  if ($[781] !== t337 || $[782] !== t339 || $[783] !== t341) {
    t342 = <tr>{t337}{t339}{t341}</tr>;
    $[781] = t337;
    $[782] = t339;
    $[783] = t341;
    $[784] = t342;
  } else {
    t342 = $[784];
  }
  let t343;
  if ($[785] !== t) {
    t343 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.7.columns.1");
    $[785] = t;
    $[786] = t343;
  } else {
    t343 = $[786];
  }
  let t344;
  if ($[787] !== t343) {
    t344 = <td className="w-56">{t343}</td>;
    $[787] = t343;
    $[788] = t344;
  } else {
    t344 = $[788];
  }
  let t345;
  if ($[789] !== t) {
    t345 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.7.columns.2");
    $[789] = t;
    $[790] = t345;
  } else {
    t345 = $[790];
  }
  let t346;
  if ($[791] !== t345) {
    t346 = <td colSpan={2} className="w-64 text-left!">{t345}</td>;
    $[791] = t345;
    $[792] = t346;
  } else {
    t346 = $[792];
  }
  let t347;
  if ($[793] !== t) {
    t347 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.7.columns.3");
    $[793] = t;
    $[794] = t347;
  } else {
    t347 = $[794];
  }
  let t348;
  if ($[795] !== t347) {
    t348 = <td colSpan={2} className="w-64 text-left!">{t347}</td>;
    $[795] = t347;
    $[796] = t348;
  } else {
    t348 = $[796];
  }
  let t349;
  if ($[797] !== t344 || $[798] !== t346 || $[799] !== t348) {
    t349 = <tr>{t344}{t346}{t348}</tr>;
    $[797] = t344;
    $[798] = t346;
    $[799] = t348;
    $[800] = t349;
  } else {
    t349 = $[800];
  }
  let t350;
  if ($[801] !== t) {
    t350 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.8.columns.1");
    $[801] = t;
    $[802] = t350;
  } else {
    t350 = $[802];
  }
  let t351;
  if ($[803] !== t350) {
    t351 = <td className="w-56">{t350}</td>;
    $[803] = t350;
    $[804] = t351;
  } else {
    t351 = $[804];
  }
  let t352;
  if ($[805] !== t) {
    t352 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.8.columns.2");
    $[805] = t;
    $[806] = t352;
  } else {
    t352 = $[806];
  }
  let t353;
  if ($[807] !== t352) {
    t353 = <td colSpan={2} className="w-64 text-left!">{t352}</td>;
    $[807] = t352;
    $[808] = t353;
  } else {
    t353 = $[808];
  }
  let t354;
  if ($[809] !== t) {
    t354 = t("seoPaymentGateway:sections.4.subsections.5.table.rows.8.columns.3");
    $[809] = t;
    $[810] = t354;
  } else {
    t354 = $[810];
  }
  let t355;
  if ($[811] !== t354) {
    t355 = <td colSpan={2} className="w-64 text-left!">{t354}</td>;
    $[811] = t354;
    $[812] = t355;
  } else {
    t355 = $[812];
  }
  let t356;
  if ($[813] !== t351 || $[814] !== t353 || $[815] !== t355) {
    t356 = <tr>{t351}{t353}{t355}</tr>;
    $[813] = t351;
    $[814] = t353;
    $[815] = t355;
    $[816] = t356;
  } else {
    t356 = $[816];
  }
  let t357;
  if ($[817] !== t307 || $[818] !== t314 || $[819] !== t321 || $[820] !== t328 || $[821] !== t335 || $[822] !== t342 || $[823] !== t349 || $[824] !== t356) {
    t357 = <>{t307}{t314}{t321}{t328}{t335}{t342}{t349}{t356}</>;
    $[817] = t307;
    $[818] = t314;
    $[819] = t321;
    $[820] = t328;
    $[821] = t335;
    $[822] = t342;
    $[823] = t349;
    $[824] = t356;
    $[825] = t357;
  } else {
    t357 = $[825];
  }
  let t358;
  if ($[826] !== t300 || $[827] !== t357) {
    t358 = <Table head={t300} body={t357} className="mt-8 mb-16" />;
    $[826] = t300;
    $[827] = t357;
    $[828] = t358;
  } else {
    t358 = $[828];
  }
  let t359;
  if ($[829] !== t289 || $[830] !== t291 || $[831] !== t293 || $[832] !== t358) {
    t359 = <>{t289}{t291}{t293}{t358}</>;
    $[829] = t289;
    $[830] = t291;
    $[831] = t293;
    $[832] = t358;
    $[833] = t359;
  } else {
    t359 = $[833];
  }
  let t360;
  if ($[834] !== t287 || $[835] !== t359) {
    t360 = {
      title: t287,
      content: t359
    };
    $[834] = t287;
    $[835] = t359;
    $[836] = t360;
  } else {
    t360 = $[836];
  }
  let t361;
  if ($[837] !== t) {
    t361 = t("seoPaymentGateway:sections.4.subsections.6.title");
    $[837] = t;
    $[838] = t361;
  } else {
    t361 = $[838];
  }
  let t362;
  if ($[839] === Symbol.for("react.memo_cache_sentinel")) {
    t362 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[839] = t362;
  } else {
    t362 = $[839];
  }
  let t363;
  if ($[840] !== t) {
    t363 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.6.content" components={t362} />;
    $[840] = t;
    $[841] = t363;
  } else {
    t363 = $[841];
  }
  let t364;
  if ($[842] === Symbol.for("react.memo_cache_sentinel")) {
    t364 = {
      minorheader: <MinorHeader />
    };
    $[842] = t364;
  } else {
    t364 = $[842];
  }
  let t365;
  if ($[843] !== t) {
    t365 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.6.subtitle1" components={t364} />;
    $[843] = t;
    $[844] = t365;
  } else {
    t365 = $[844];
  }
  let t366;
  if ($[845] !== t) {
    t366 = t("seoPaymentGateway:sections.4.subsections.6.props");
    $[845] = t;
    $[846] = t366;
  } else {
    t366 = $[846];
  }
  let t367;
  if ($[847] !== t366) {
    t367 = <PropsConsList items={[t366]} variant="props" />;
    $[847] = t366;
    $[848] = t367;
  } else {
    t367 = $[848];
  }
  let t368;
  if ($[849] === Symbol.for("react.memo_cache_sentinel")) {
    t368 = {
      minorheader: <MinorHeader />
    };
    $[849] = t368;
  } else {
    t368 = $[849];
  }
  let t369;
  if ($[850] !== t) {
    t369 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.6.subtitle2" components={t368} />;
    $[850] = t;
    $[851] = t369;
  } else {
    t369 = $[851];
  }
  let t370;
  if ($[852] !== t) {
    t370 = t("seoPaymentGateway:sections.4.subsections.6.cons");
    $[852] = t;
    $[853] = t370;
  } else {
    t370 = $[853];
  }
  let t371;
  if ($[854] !== t370) {
    t371 = <PropsConsList items={[t370]} variant="cons" />;
    $[854] = t370;
    $[855] = t371;
  } else {
    t371 = $[855];
  }
  let t372;
  if ($[856] !== t) {
    t372 = t("seoPaymentGateway:sections.4.subsections.6.table.headers.1");
    $[856] = t;
    $[857] = t372;
  } else {
    t372 = $[857];
  }
  let t373;
  if ($[858] !== t372) {
    t373 = <th className="w-56 rounded-tr-none!">{t372}</th>;
    $[858] = t372;
    $[859] = t373;
  } else {
    t373 = $[859];
  }
  let t374;
  if ($[860] !== t) {
    t374 = t("seoPaymentGateway:sections.4.subsections.6.table.headers.2");
    $[860] = t;
    $[861] = t374;
  } else {
    t374 = $[861];
  }
  let t375;
  if ($[862] !== t374) {
    t375 = <th colSpan={2} className="w-64">{t374}</th>;
    $[862] = t374;
    $[863] = t375;
  } else {
    t375 = $[863];
  }
  let t376;
  if ($[864] !== t) {
    t376 = t("seoPaymentGateway:sections.4.subsections.6.table.headers.3");
    $[864] = t;
    $[865] = t376;
  } else {
    t376 = $[865];
  }
  let t377;
  if ($[866] !== t376) {
    t377 = <th colSpan={2} className="w-64 rounded-tr-md">{t376}</th>;
    $[866] = t376;
    $[867] = t377;
  } else {
    t377 = $[867];
  }
  let t378;
  if ($[868] !== t373 || $[869] !== t375 || $[870] !== t377) {
    t378 = <tr>{t373}{t375}{t377}</tr>;
    $[868] = t373;
    $[869] = t375;
    $[870] = t377;
    $[871] = t378;
  } else {
    t378 = $[871];
  }
  let t379;
  if ($[872] !== t) {
    t379 = t("seoPaymentGateway:sections.4.subsections.6.table.rows.1.columns.1");
    $[872] = t;
    $[873] = t379;
  } else {
    t379 = $[873];
  }
  let t380;
  if ($[874] !== t379) {
    t380 = <td className="w-56">{t379}</td>;
    $[874] = t379;
    $[875] = t380;
  } else {
    t380 = $[875];
  }
  let t381;
  if ($[876] !== t) {
    t381 = t("seoPaymentGateway:sections.4.subsections.6.table.rows.1.columns.2");
    $[876] = t;
    $[877] = t381;
  } else {
    t381 = $[877];
  }
  let t382;
  if ($[878] !== t381) {
    t382 = <td colSpan={2} className="w-64 text-left!">{t381}</td>;
    $[878] = t381;
    $[879] = t382;
  } else {
    t382 = $[879];
  }
  let t383;
  if ($[880] !== t) {
    t383 = t("seoPaymentGateway:sections.4.subsections.6.table.rows.1.columns.3");
    $[880] = t;
    $[881] = t383;
  } else {
    t383 = $[881];
  }
  let t384;
  if ($[882] !== t383) {
    t384 = <td colSpan={2} className="w-64 text-left!">{t383}</td>;
    $[882] = t383;
    $[883] = t384;
  } else {
    t384 = $[883];
  }
  let t385;
  if ($[884] !== t380 || $[885] !== t382 || $[886] !== t384) {
    t385 = <tr>{t380}{t382}{t384}</tr>;
    $[884] = t380;
    $[885] = t382;
    $[886] = t384;
    $[887] = t385;
  } else {
    t385 = $[887];
  }
  let t386;
  if ($[888] !== t378 || $[889] !== t385) {
    t386 = <Table head={t378} body={t385} className="mt-8 mb-16" />;
    $[888] = t378;
    $[889] = t385;
    $[890] = t386;
  } else {
    t386 = $[890];
  }
  let t387;
  if ($[891] !== t363 || $[892] !== t365 || $[893] !== t367 || $[894] !== t369 || $[895] !== t371 || $[896] !== t386) {
    t387 = <>{t363}{t365}{t367}{t369}{t371}{t386}</>;
    $[891] = t363;
    $[892] = t365;
    $[893] = t367;
    $[894] = t369;
    $[895] = t371;
    $[896] = t386;
    $[897] = t387;
  } else {
    t387 = $[897];
  }
  let t388;
  if ($[898] !== t361 || $[899] !== t387) {
    t388 = {
      title: t361,
      content: t387
    };
    $[898] = t361;
    $[899] = t387;
    $[900] = t388;
  } else {
    t388 = $[900];
  }
  let t389;
  if ($[901] !== t) {
    t389 = t("seoPaymentGateway:sections.4.subsections.7.title");
    $[901] = t;
    $[902] = t389;
  } else {
    t389 = $[902];
  }
  let t390;
  if ($[903] === Symbol.for("react.memo_cache_sentinel")) {
    t390 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[903] = t390;
  } else {
    t390 = $[903];
  }
  let t391;
  if ($[904] !== t) {
    t391 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.7.content" components={t390} />;
    $[904] = t;
    $[905] = t391;
  } else {
    t391 = $[905];
  }
  let t392;
  if ($[906] === Symbol.for("react.memo_cache_sentinel")) {
    t392 = {
      minorheader: <MinorHeader />
    };
    $[906] = t392;
  } else {
    t392 = $[906];
  }
  let t393;
  if ($[907] !== t) {
    t393 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.7.subtitle1" components={t392} />;
    $[907] = t;
    $[908] = t393;
  } else {
    t393 = $[908];
  }
  let t394;
  if ($[909] === Symbol.for("react.memo_cache_sentinel")) {
    t394 = [...Array(4)];
    $[909] = t394;
  } else {
    t394 = $[909];
  }
  let t395;
  if ($[910] !== t) {
    t395 = <PropsConsList items={t394.map((__4, i_4) => {
      const transIndex_4 = i_4 + 1 as NumericRange<1, 4>;
      return <Trans key={i_4} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.7.props.${transIndex_4}`} />;
    })} variant="props" />;
    $[910] = t;
    $[911] = t395;
  } else {
    t395 = $[911];
  }
  let t396;
  if ($[912] === Symbol.for("react.memo_cache_sentinel")) {
    t396 = {
      minorheader: <MinorHeader />
    };
    $[912] = t396;
  } else {
    t396 = $[912];
  }
  let t397;
  if ($[913] !== t) {
    t397 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.7.subtitle2" components={t396} />;
    $[913] = t;
    $[914] = t397;
  } else {
    t397 = $[914];
  }
  let t398;
  if ($[915] === Symbol.for("react.memo_cache_sentinel")) {
    t398 = [...Array(3)];
    $[915] = t398;
  } else {
    t398 = $[915];
  }
  let t399;
  if ($[916] !== t) {
    t399 = <PropsConsList items={t398.map((__5, i_5) => {
      const transIndex_5 = i_5 + 1 as NumericRange<1, 3>;
      return <Trans key={i_5} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.7.cons.${transIndex_5}`} />;
    })} variant="cons" />;
    $[916] = t;
    $[917] = t399;
  } else {
    t399 = $[917];
  }
  let t400;
  if ($[918] !== t) {
    t400 = t("seoPaymentGateway:sections.4.subsections.7.table.headers.1");
    $[918] = t;
    $[919] = t400;
  } else {
    t400 = $[919];
  }
  let t401;
  if ($[920] !== t400) {
    t401 = <th className="w-56 rounded-tr-none!">{t400}</th>;
    $[920] = t400;
    $[921] = t401;
  } else {
    t401 = $[921];
  }
  let t402;
  if ($[922] !== t) {
    t402 = t("seoPaymentGateway:sections.4.subsections.7.table.headers.2");
    $[922] = t;
    $[923] = t402;
  } else {
    t402 = $[923];
  }
  let t403;
  if ($[924] !== t402) {
    t403 = <th colSpan={2} className="w-64">{t402}</th>;
    $[924] = t402;
    $[925] = t403;
  } else {
    t403 = $[925];
  }
  let t404;
  if ($[926] !== t) {
    t404 = t("seoPaymentGateway:sections.4.subsections.7.table.headers.3");
    $[926] = t;
    $[927] = t404;
  } else {
    t404 = $[927];
  }
  let t405;
  if ($[928] !== t404) {
    t405 = <th colSpan={2} className="w-64 rounded-tr-md">{t404}</th>;
    $[928] = t404;
    $[929] = t405;
  } else {
    t405 = $[929];
  }
  let t406;
  if ($[930] !== t401 || $[931] !== t403 || $[932] !== t405) {
    t406 = <tr>{t401}{t403}{t405}</tr>;
    $[930] = t401;
    $[931] = t403;
    $[932] = t405;
    $[933] = t406;
  } else {
    t406 = $[933];
  }
  let t407;
  if ($[934] !== t) {
    t407 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.1.columns.1");
    $[934] = t;
    $[935] = t407;
  } else {
    t407 = $[935];
  }
  let t408;
  if ($[936] !== t407) {
    t408 = <td className="w-56">{t407}</td>;
    $[936] = t407;
    $[937] = t408;
  } else {
    t408 = $[937];
  }
  let t409;
  if ($[938] !== t) {
    t409 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.1.columns.2");
    $[938] = t;
    $[939] = t409;
  } else {
    t409 = $[939];
  }
  let t410;
  if ($[940] !== t409) {
    t410 = <td colSpan={2} className="w-64 text-left!">{t409}</td>;
    $[940] = t409;
    $[941] = t410;
  } else {
    t410 = $[941];
  }
  let t411;
  if ($[942] !== t) {
    t411 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.1.columns.3");
    $[942] = t;
    $[943] = t411;
  } else {
    t411 = $[943];
  }
  let t412;
  if ($[944] !== t411) {
    t412 = <td colSpan={2} className="w-64 text-left!">{t411}</td>;
    $[944] = t411;
    $[945] = t412;
  } else {
    t412 = $[945];
  }
  let t413;
  if ($[946] !== t408 || $[947] !== t410 || $[948] !== t412) {
    t413 = <tr>{t408}{t410}{t412}</tr>;
    $[946] = t408;
    $[947] = t410;
    $[948] = t412;
    $[949] = t413;
  } else {
    t413 = $[949];
  }
  let t414;
  if ($[950] !== t) {
    t414 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.2.columns.1");
    $[950] = t;
    $[951] = t414;
  } else {
    t414 = $[951];
  }
  let t415;
  if ($[952] !== t414) {
    t415 = <td className="w-56">{t414}</td>;
    $[952] = t414;
    $[953] = t415;
  } else {
    t415 = $[953];
  }
  let t416;
  if ($[954] !== t) {
    t416 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.2.columns.2");
    $[954] = t;
    $[955] = t416;
  } else {
    t416 = $[955];
  }
  let t417;
  if ($[956] !== t416) {
    t417 = <td colSpan={2} className="w-64 text-left!">{t416}</td>;
    $[956] = t416;
    $[957] = t417;
  } else {
    t417 = $[957];
  }
  let t418;
  if ($[958] !== t) {
    t418 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.2.columns.3");
    $[958] = t;
    $[959] = t418;
  } else {
    t418 = $[959];
  }
  let t419;
  if ($[960] !== t418) {
    t419 = <td colSpan={2} className="w-64 text-left!">{t418}</td>;
    $[960] = t418;
    $[961] = t419;
  } else {
    t419 = $[961];
  }
  let t420;
  if ($[962] !== t415 || $[963] !== t417 || $[964] !== t419) {
    t420 = <tr>{t415}{t417}{t419}</tr>;
    $[962] = t415;
    $[963] = t417;
    $[964] = t419;
    $[965] = t420;
  } else {
    t420 = $[965];
  }
  let t421;
  if ($[966] !== t) {
    t421 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.3.columns.1");
    $[966] = t;
    $[967] = t421;
  } else {
    t421 = $[967];
  }
  let t422;
  if ($[968] !== t421) {
    t422 = <td className="w-56">{t421}</td>;
    $[968] = t421;
    $[969] = t422;
  } else {
    t422 = $[969];
  }
  let t423;
  if ($[970] !== t) {
    t423 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.3.columns.2");
    $[970] = t;
    $[971] = t423;
  } else {
    t423 = $[971];
  }
  let t424;
  if ($[972] !== t423) {
    t424 = <td colSpan={2} className="w-64 text-left!">{t423}</td>;
    $[972] = t423;
    $[973] = t424;
  } else {
    t424 = $[973];
  }
  let t425;
  if ($[974] !== t) {
    t425 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.3.columns.3");
    $[974] = t;
    $[975] = t425;
  } else {
    t425 = $[975];
  }
  let t426;
  if ($[976] !== t425) {
    t426 = <td colSpan={2} className="w-64 text-left!">{t425}</td>;
    $[976] = t425;
    $[977] = t426;
  } else {
    t426 = $[977];
  }
  let t427;
  if ($[978] !== t422 || $[979] !== t424 || $[980] !== t426) {
    t427 = <tr>{t422}{t424}{t426}</tr>;
    $[978] = t422;
    $[979] = t424;
    $[980] = t426;
    $[981] = t427;
  } else {
    t427 = $[981];
  }
  let t428;
  if ($[982] !== t) {
    t428 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.4.columns.1");
    $[982] = t;
    $[983] = t428;
  } else {
    t428 = $[983];
  }
  let t429;
  if ($[984] !== t428) {
    t429 = <td className="w-56">{t428}</td>;
    $[984] = t428;
    $[985] = t429;
  } else {
    t429 = $[985];
  }
  let t430;
  if ($[986] !== t) {
    t430 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.4.columns.2");
    $[986] = t;
    $[987] = t430;
  } else {
    t430 = $[987];
  }
  let t431;
  if ($[988] !== t430) {
    t431 = <td colSpan={2} className="w-64 text-left!">{t430}</td>;
    $[988] = t430;
    $[989] = t431;
  } else {
    t431 = $[989];
  }
  let t432;
  if ($[990] !== t) {
    t432 = t("seoPaymentGateway:sections.4.subsections.7.table.rows.4.columns.3");
    $[990] = t;
    $[991] = t432;
  } else {
    t432 = $[991];
  }
  let t433;
  if ($[992] !== t432) {
    t433 = <td colSpan={2} className="w-64 text-left!">{t432}</td>;
    $[992] = t432;
    $[993] = t433;
  } else {
    t433 = $[993];
  }
  let t434;
  if ($[994] !== t429 || $[995] !== t431 || $[996] !== t433) {
    t434 = <tr>{t429}{t431}{t433}</tr>;
    $[994] = t429;
    $[995] = t431;
    $[996] = t433;
    $[997] = t434;
  } else {
    t434 = $[997];
  }
  let t435;
  if ($[998] !== t413 || $[999] !== t420 || $[1000] !== t427 || $[1001] !== t434) {
    t435 = <>{t413}{t420}{t427}{t434}</>;
    $[998] = t413;
    $[999] = t420;
    $[1000] = t427;
    $[1001] = t434;
    $[1002] = t435;
  } else {
    t435 = $[1002];
  }
  let t436;
  if ($[1003] !== t406 || $[1004] !== t435) {
    t436 = <Table head={t406} body={t435} className="mt-8 mb-16" />;
    $[1003] = t406;
    $[1004] = t435;
    $[1005] = t436;
  } else {
    t436 = $[1005];
  }
  let t437;
  if ($[1006] !== t391 || $[1007] !== t393 || $[1008] !== t395 || $[1009] !== t397 || $[1010] !== t399 || $[1011] !== t436) {
    t437 = <>{t391}{t393}{t395}{t397}{t399}{t436}</>;
    $[1006] = t391;
    $[1007] = t393;
    $[1008] = t395;
    $[1009] = t397;
    $[1010] = t399;
    $[1011] = t436;
    $[1012] = t437;
  } else {
    t437 = $[1012];
  }
  let t438;
  if ($[1013] !== t389 || $[1014] !== t437) {
    t438 = {
      title: t389,
      content: t437
    };
    $[1013] = t389;
    $[1014] = t437;
    $[1015] = t438;
  } else {
    t438 = $[1015];
  }
  let t439;
  if ($[1016] !== t) {
    t439 = t("seoPaymentGateway:sections.4.subsections.8.title");
    $[1016] = t;
    $[1017] = t439;
  } else {
    t439 = $[1017];
  }
  let t440;
  if ($[1018] === Symbol.for("react.memo_cache_sentinel")) {
    t440 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1018] = t440;
  } else {
    t440 = $[1018];
  }
  let t441;
  if ($[1019] !== t) {
    t441 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.8.content" components={t440} />;
    $[1019] = t;
    $[1020] = t441;
  } else {
    t441 = $[1020];
  }
  let t442;
  if ($[1021] === Symbol.for("react.memo_cache_sentinel")) {
    t442 = {
      minorheader: <MinorHeader />
    };
    $[1021] = t442;
  } else {
    t442 = $[1021];
  }
  let t443;
  if ($[1022] !== t) {
    t443 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.8.subtitle1" components={t442} />;
    $[1022] = t;
    $[1023] = t443;
  } else {
    t443 = $[1023];
  }
  let t444;
  if ($[1024] === Symbol.for("react.memo_cache_sentinel")) {
    t444 = [...Array(4)];
    $[1024] = t444;
  } else {
    t444 = $[1024];
  }
  let t445;
  if ($[1025] !== t) {
    t445 = <PropsConsList items={t444.map((__6, i_6) => {
      const transIndex_6 = i_6 + 1 as NumericRange<1, 4>;
      return <Trans key={i_6} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.8.props.${transIndex_6}`} />;
    })} variant="props" />;
    $[1025] = t;
    $[1026] = t445;
  } else {
    t445 = $[1026];
  }
  let t446;
  if ($[1027] === Symbol.for("react.memo_cache_sentinel")) {
    t446 = {
      minorheader: <MinorHeader />
    };
    $[1027] = t446;
  } else {
    t446 = $[1027];
  }
  let t447;
  if ($[1028] !== t) {
    t447 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.8.subtitle2" components={t446} />;
    $[1028] = t;
    $[1029] = t447;
  } else {
    t447 = $[1029];
  }
  let t448;
  if ($[1030] === Symbol.for("react.memo_cache_sentinel")) {
    t448 = [...Array(2)];
    $[1030] = t448;
  } else {
    t448 = $[1030];
  }
  let t449;
  if ($[1031] !== t) {
    t449 = <PropsConsList items={t448.map((__7, i_7) => {
      const transIndex_7 = i_7 + 1 as NumericRange<1, 2>;
      return <Trans key={i_7} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.8.cons.${transIndex_7}`} />;
    })} variant="cons" />;
    $[1031] = t;
    $[1032] = t449;
  } else {
    t449 = $[1032];
  }
  let t450;
  if ($[1033] !== t) {
    t450 = t("seoPaymentGateway:sections.4.subsections.8.table.headers.1");
    $[1033] = t;
    $[1034] = t450;
  } else {
    t450 = $[1034];
  }
  let t451;
  if ($[1035] !== t450) {
    t451 = <th className="w-56 rounded-tr-none!">{t450}</th>;
    $[1035] = t450;
    $[1036] = t451;
  } else {
    t451 = $[1036];
  }
  let t452;
  if ($[1037] !== t) {
    t452 = t("seoPaymentGateway:sections.4.subsections.8.table.headers.2");
    $[1037] = t;
    $[1038] = t452;
  } else {
    t452 = $[1038];
  }
  let t453;
  if ($[1039] !== t452) {
    t453 = <th colSpan={2} className="w-64">{t452}</th>;
    $[1039] = t452;
    $[1040] = t453;
  } else {
    t453 = $[1040];
  }
  let t454;
  if ($[1041] !== t) {
    t454 = t("seoPaymentGateway:sections.4.subsections.8.table.headers.3");
    $[1041] = t;
    $[1042] = t454;
  } else {
    t454 = $[1042];
  }
  let t455;
  if ($[1043] !== t454) {
    t455 = <th colSpan={2} className="w-64 rounded-tr-md">{t454}</th>;
    $[1043] = t454;
    $[1044] = t455;
  } else {
    t455 = $[1044];
  }
  let t456;
  if ($[1045] !== t451 || $[1046] !== t453 || $[1047] !== t455) {
    t456 = <tr>{t451}{t453}{t455}</tr>;
    $[1045] = t451;
    $[1046] = t453;
    $[1047] = t455;
    $[1048] = t456;
  } else {
    t456 = $[1048];
  }
  let t457;
  if ($[1049] !== t) {
    t457 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.1.columns.1");
    $[1049] = t;
    $[1050] = t457;
  } else {
    t457 = $[1050];
  }
  let t458;
  if ($[1051] !== t457) {
    t458 = <td className="w-56">{t457}</td>;
    $[1051] = t457;
    $[1052] = t458;
  } else {
    t458 = $[1052];
  }
  let t459;
  if ($[1053] !== t) {
    t459 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.1.columns.2");
    $[1053] = t;
    $[1054] = t459;
  } else {
    t459 = $[1054];
  }
  let t460;
  if ($[1055] !== t459) {
    t460 = <td colSpan={2} className="w-64 text-left!">{t459}</td>;
    $[1055] = t459;
    $[1056] = t460;
  } else {
    t460 = $[1056];
  }
  let t461;
  if ($[1057] !== t) {
    t461 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.1.columns.3");
    $[1057] = t;
    $[1058] = t461;
  } else {
    t461 = $[1058];
  }
  let t462;
  if ($[1059] !== t461) {
    t462 = <td colSpan={2} className="w-64 text-left!">{t461}</td>;
    $[1059] = t461;
    $[1060] = t462;
  } else {
    t462 = $[1060];
  }
  let t463;
  if ($[1061] !== t458 || $[1062] !== t460 || $[1063] !== t462) {
    t463 = <tr>{t458}{t460}{t462}</tr>;
    $[1061] = t458;
    $[1062] = t460;
    $[1063] = t462;
    $[1064] = t463;
  } else {
    t463 = $[1064];
  }
  let t464;
  if ($[1065] !== t) {
    t464 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.2.columns.1");
    $[1065] = t;
    $[1066] = t464;
  } else {
    t464 = $[1066];
  }
  let t465;
  if ($[1067] !== t464) {
    t465 = <td className="w-56">{t464}</td>;
    $[1067] = t464;
    $[1068] = t465;
  } else {
    t465 = $[1068];
  }
  let t466;
  if ($[1069] !== t) {
    t466 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.2.columns.2");
    $[1069] = t;
    $[1070] = t466;
  } else {
    t466 = $[1070];
  }
  let t467;
  if ($[1071] !== t466) {
    t467 = <td colSpan={2} className="w-64 text-left!">{t466}</td>;
    $[1071] = t466;
    $[1072] = t467;
  } else {
    t467 = $[1072];
  }
  let t468;
  if ($[1073] !== t) {
    t468 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.2.columns.3");
    $[1073] = t;
    $[1074] = t468;
  } else {
    t468 = $[1074];
  }
  let t469;
  if ($[1075] !== t468) {
    t469 = <td colSpan={2} className="w-64 text-left!">{t468}</td>;
    $[1075] = t468;
    $[1076] = t469;
  } else {
    t469 = $[1076];
  }
  let t470;
  if ($[1077] !== t465 || $[1078] !== t467 || $[1079] !== t469) {
    t470 = <tr>{t465}{t467}{t469}</tr>;
    $[1077] = t465;
    $[1078] = t467;
    $[1079] = t469;
    $[1080] = t470;
  } else {
    t470 = $[1080];
  }
  let t471;
  if ($[1081] !== t) {
    t471 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.3.columns.1");
    $[1081] = t;
    $[1082] = t471;
  } else {
    t471 = $[1082];
  }
  let t472;
  if ($[1083] !== t471) {
    t472 = <td className="w-56">{t471}</td>;
    $[1083] = t471;
    $[1084] = t472;
  } else {
    t472 = $[1084];
  }
  let t473;
  if ($[1085] !== t) {
    t473 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.3.columns.2");
    $[1085] = t;
    $[1086] = t473;
  } else {
    t473 = $[1086];
  }
  let t474;
  if ($[1087] !== t473) {
    t474 = <td colSpan={2} className="w-64 text-left!">{t473}</td>;
    $[1087] = t473;
    $[1088] = t474;
  } else {
    t474 = $[1088];
  }
  let t475;
  if ($[1089] !== t) {
    t475 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.3.columns.3");
    $[1089] = t;
    $[1090] = t475;
  } else {
    t475 = $[1090];
  }
  let t476;
  if ($[1091] !== t475) {
    t476 = <td colSpan={2} className="w-64 text-left!">{t475}</td>;
    $[1091] = t475;
    $[1092] = t476;
  } else {
    t476 = $[1092];
  }
  let t477;
  if ($[1093] !== t472 || $[1094] !== t474 || $[1095] !== t476) {
    t477 = <tr>{t472}{t474}{t476}</tr>;
    $[1093] = t472;
    $[1094] = t474;
    $[1095] = t476;
    $[1096] = t477;
  } else {
    t477 = $[1096];
  }
  let t478;
  if ($[1097] !== t) {
    t478 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.4.columns.1");
    $[1097] = t;
    $[1098] = t478;
  } else {
    t478 = $[1098];
  }
  let t479;
  if ($[1099] !== t478) {
    t479 = <td className="w-56">{t478}</td>;
    $[1099] = t478;
    $[1100] = t479;
  } else {
    t479 = $[1100];
  }
  let t480;
  if ($[1101] !== t) {
    t480 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.4.columns.2");
    $[1101] = t;
    $[1102] = t480;
  } else {
    t480 = $[1102];
  }
  let t481;
  if ($[1103] !== t480) {
    t481 = <td colSpan={2} className="w-64 text-left!">{t480}</td>;
    $[1103] = t480;
    $[1104] = t481;
  } else {
    t481 = $[1104];
  }
  let t482;
  if ($[1105] !== t) {
    t482 = t("seoPaymentGateway:sections.4.subsections.8.table.rows.4.columns.3");
    $[1105] = t;
    $[1106] = t482;
  } else {
    t482 = $[1106];
  }
  let t483;
  if ($[1107] !== t482) {
    t483 = <td colSpan={2} className="w-64 text-left!">{t482}</td>;
    $[1107] = t482;
    $[1108] = t483;
  } else {
    t483 = $[1108];
  }
  let t484;
  if ($[1109] !== t479 || $[1110] !== t481 || $[1111] !== t483) {
    t484 = <tr>{t479}{t481}{t483}</tr>;
    $[1109] = t479;
    $[1110] = t481;
    $[1111] = t483;
    $[1112] = t484;
  } else {
    t484 = $[1112];
  }
  let t485;
  if ($[1113] !== t463 || $[1114] !== t470 || $[1115] !== t477 || $[1116] !== t484) {
    t485 = <>{t463}{t470}{t477}{t484}</>;
    $[1113] = t463;
    $[1114] = t470;
    $[1115] = t477;
    $[1116] = t484;
    $[1117] = t485;
  } else {
    t485 = $[1117];
  }
  let t486;
  if ($[1118] !== t456 || $[1119] !== t485) {
    t486 = <Table head={t456} body={t485} className="mt-8 mb-16" />;
    $[1118] = t456;
    $[1119] = t485;
    $[1120] = t486;
  } else {
    t486 = $[1120];
  }
  let t487;
  if ($[1121] !== t441 || $[1122] !== t443 || $[1123] !== t445 || $[1124] !== t447 || $[1125] !== t449 || $[1126] !== t486) {
    t487 = <>{t441}{t443}{t445}{t447}{t449}{t486}</>;
    $[1121] = t441;
    $[1122] = t443;
    $[1123] = t445;
    $[1124] = t447;
    $[1125] = t449;
    $[1126] = t486;
    $[1127] = t487;
  } else {
    t487 = $[1127];
  }
  let t488;
  if ($[1128] !== t439 || $[1129] !== t487) {
    t488 = {
      title: t439,
      content: t487
    };
    $[1128] = t439;
    $[1129] = t487;
    $[1130] = t488;
  } else {
    t488 = $[1130];
  }
  let t489;
  if ($[1131] !== t) {
    t489 = t("seoPaymentGateway:sections.4.subsections.9.title");
    $[1131] = t;
    $[1132] = t489;
  } else {
    t489 = $[1132];
  }
  let t490;
  if ($[1133] === Symbol.for("react.memo_cache_sentinel")) {
    t490 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1133] = t490;
  } else {
    t490 = $[1133];
  }
  let t491;
  if ($[1134] !== t) {
    t491 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.9.content" components={t490} />;
    $[1134] = t;
    $[1135] = t491;
  } else {
    t491 = $[1135];
  }
  let t492;
  if ($[1136] === Symbol.for("react.memo_cache_sentinel")) {
    t492 = {
      minorheader: <MinorHeader />
    };
    $[1136] = t492;
  } else {
    t492 = $[1136];
  }
  let t493;
  if ($[1137] !== t) {
    t493 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.9.subtitle1" components={t492} />;
    $[1137] = t;
    $[1138] = t493;
  } else {
    t493 = $[1138];
  }
  let t494;
  if ($[1139] === Symbol.for("react.memo_cache_sentinel")) {
    t494 = [...Array(2)];
    $[1139] = t494;
  } else {
    t494 = $[1139];
  }
  let t495;
  if ($[1140] !== t) {
    t495 = <PropsConsList items={t494.map((__8, i_8) => {
      const transIndex_8 = i_8 + 1 as NumericRange<1, 2>;
      return <Trans key={i_8} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.9.props.${transIndex_8}`} />;
    })} variant="props" />;
    $[1140] = t;
    $[1141] = t495;
  } else {
    t495 = $[1141];
  }
  let t496;
  if ($[1142] === Symbol.for("react.memo_cache_sentinel")) {
    t496 = {
      minorheader: <MinorHeader />
    };
    $[1142] = t496;
  } else {
    t496 = $[1142];
  }
  let t497;
  if ($[1143] !== t) {
    t497 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.9.subtitle2" components={t496} />;
    $[1143] = t;
    $[1144] = t497;
  } else {
    t497 = $[1144];
  }
  let t498;
  if ($[1145] !== t) {
    t498 = t("seoPaymentGateway:sections.4.subsections.9.cons");
    $[1145] = t;
    $[1146] = t498;
  } else {
    t498 = $[1146];
  }
  let t499;
  if ($[1147] !== t498) {
    t499 = <PropsConsList items={[t498]} variant="cons" />;
    $[1147] = t498;
    $[1148] = t499;
  } else {
    t499 = $[1148];
  }
  let t500;
  if ($[1149] !== t) {
    t500 = t("seoPaymentGateway:sections.4.subsections.9.table.headers.1");
    $[1149] = t;
    $[1150] = t500;
  } else {
    t500 = $[1150];
  }
  let t501;
  if ($[1151] !== t500) {
    t501 = <th className="w-56 rounded-tr-none!">{t500}</th>;
    $[1151] = t500;
    $[1152] = t501;
  } else {
    t501 = $[1152];
  }
  let t502;
  if ($[1153] !== t) {
    t502 = t("seoPaymentGateway:sections.4.subsections.9.table.headers.2");
    $[1153] = t;
    $[1154] = t502;
  } else {
    t502 = $[1154];
  }
  let t503;
  if ($[1155] !== t502) {
    t503 = <th colSpan={2} className="w-64">{t502}</th>;
    $[1155] = t502;
    $[1156] = t503;
  } else {
    t503 = $[1156];
  }
  let t504;
  if ($[1157] !== t) {
    t504 = t("seoPaymentGateway:sections.4.subsections.9.table.headers.3");
    $[1157] = t;
    $[1158] = t504;
  } else {
    t504 = $[1158];
  }
  let t505;
  if ($[1159] !== t504) {
    t505 = <th colSpan={2} className="w-64 rounded-tr-md">{t504}</th>;
    $[1159] = t504;
    $[1160] = t505;
  } else {
    t505 = $[1160];
  }
  let t506;
  if ($[1161] !== t501 || $[1162] !== t503 || $[1163] !== t505) {
    t506 = <tr>{t501}{t503}{t505}</tr>;
    $[1161] = t501;
    $[1162] = t503;
    $[1163] = t505;
    $[1164] = t506;
  } else {
    t506 = $[1164];
  }
  let t507;
  if ($[1165] !== t) {
    t507 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.1.columns.1");
    $[1165] = t;
    $[1166] = t507;
  } else {
    t507 = $[1166];
  }
  let t508;
  if ($[1167] !== t507) {
    t508 = <td className="w-56">{t507}</td>;
    $[1167] = t507;
    $[1168] = t508;
  } else {
    t508 = $[1168];
  }
  let t509;
  if ($[1169] !== t) {
    t509 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.1.columns.2");
    $[1169] = t;
    $[1170] = t509;
  } else {
    t509 = $[1170];
  }
  let t510;
  if ($[1171] !== t509) {
    t510 = <td colSpan={2} className="w-64 text-left!">{t509}</td>;
    $[1171] = t509;
    $[1172] = t510;
  } else {
    t510 = $[1172];
  }
  let t511;
  if ($[1173] !== t) {
    t511 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.1.columns.3");
    $[1173] = t;
    $[1174] = t511;
  } else {
    t511 = $[1174];
  }
  let t512;
  if ($[1175] !== t511) {
    t512 = <td colSpan={2} className="w-64 text-left!">{t511}</td>;
    $[1175] = t511;
    $[1176] = t512;
  } else {
    t512 = $[1176];
  }
  let t513;
  if ($[1177] !== t508 || $[1178] !== t510 || $[1179] !== t512) {
    t513 = <tr>{t508}{t510}{t512}</tr>;
    $[1177] = t508;
    $[1178] = t510;
    $[1179] = t512;
    $[1180] = t513;
  } else {
    t513 = $[1180];
  }
  let t514;
  if ($[1181] !== t) {
    t514 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.2.columns.1");
    $[1181] = t;
    $[1182] = t514;
  } else {
    t514 = $[1182];
  }
  let t515;
  if ($[1183] !== t514) {
    t515 = <td className="w-56">{t514}</td>;
    $[1183] = t514;
    $[1184] = t515;
  } else {
    t515 = $[1184];
  }
  let t516;
  if ($[1185] !== t) {
    t516 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.2.columns.2");
    $[1185] = t;
    $[1186] = t516;
  } else {
    t516 = $[1186];
  }
  let t517;
  if ($[1187] !== t516) {
    t517 = <td colSpan={2} className="w-64 text-left!">{t516}</td>;
    $[1187] = t516;
    $[1188] = t517;
  } else {
    t517 = $[1188];
  }
  let t518;
  if ($[1189] !== t) {
    t518 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.2.columns.3");
    $[1189] = t;
    $[1190] = t518;
  } else {
    t518 = $[1190];
  }
  let t519;
  if ($[1191] !== t518) {
    t519 = <td colSpan={2} className="w-64 text-left!">{t518}</td>;
    $[1191] = t518;
    $[1192] = t519;
  } else {
    t519 = $[1192];
  }
  let t520;
  if ($[1193] !== t515 || $[1194] !== t517 || $[1195] !== t519) {
    t520 = <tr>{t515}{t517}{t519}</tr>;
    $[1193] = t515;
    $[1194] = t517;
    $[1195] = t519;
    $[1196] = t520;
  } else {
    t520 = $[1196];
  }
  let t521;
  if ($[1197] !== t) {
    t521 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.3.columns.1");
    $[1197] = t;
    $[1198] = t521;
  } else {
    t521 = $[1198];
  }
  let t522;
  if ($[1199] !== t521) {
    t522 = <td className="w-56">{t521}</td>;
    $[1199] = t521;
    $[1200] = t522;
  } else {
    t522 = $[1200];
  }
  let t523;
  if ($[1201] !== t) {
    t523 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.3.columns.2");
    $[1201] = t;
    $[1202] = t523;
  } else {
    t523 = $[1202];
  }
  let t524;
  if ($[1203] !== t523) {
    t524 = <td colSpan={2} className="w-64 text-left!">{t523}</td>;
    $[1203] = t523;
    $[1204] = t524;
  } else {
    t524 = $[1204];
  }
  let t525;
  if ($[1205] !== t) {
    t525 = t("seoPaymentGateway:sections.4.subsections.9.table.rows.3.columns.3");
    $[1205] = t;
    $[1206] = t525;
  } else {
    t525 = $[1206];
  }
  let t526;
  if ($[1207] !== t525) {
    t526 = <td colSpan={2} className="w-64 text-left!">{t525}</td>;
    $[1207] = t525;
    $[1208] = t526;
  } else {
    t526 = $[1208];
  }
  let t527;
  if ($[1209] !== t522 || $[1210] !== t524 || $[1211] !== t526) {
    t527 = <tr>{t522}{t524}{t526}</tr>;
    $[1209] = t522;
    $[1210] = t524;
    $[1211] = t526;
    $[1212] = t527;
  } else {
    t527 = $[1212];
  }
  let t528;
  if ($[1213] !== t513 || $[1214] !== t520 || $[1215] !== t527) {
    t528 = <>{t513}{t520}{t527}</>;
    $[1213] = t513;
    $[1214] = t520;
    $[1215] = t527;
    $[1216] = t528;
  } else {
    t528 = $[1216];
  }
  let t529;
  if ($[1217] !== t506 || $[1218] !== t528) {
    t529 = <Table head={t506} body={t528} className="mt-8 mb-16" />;
    $[1217] = t506;
    $[1218] = t528;
    $[1219] = t529;
  } else {
    t529 = $[1219];
  }
  let t530;
  if ($[1220] !== t491 || $[1221] !== t493 || $[1222] !== t495 || $[1223] !== t497 || $[1224] !== t499 || $[1225] !== t529) {
    t530 = <>{t491}{t493}{t495}{t497}{t499}{t529}</>;
    $[1220] = t491;
    $[1221] = t493;
    $[1222] = t495;
    $[1223] = t497;
    $[1224] = t499;
    $[1225] = t529;
    $[1226] = t530;
  } else {
    t530 = $[1226];
  }
  let t531;
  if ($[1227] !== t489 || $[1228] !== t530) {
    t531 = {
      title: t489,
      content: t530
    };
    $[1227] = t489;
    $[1228] = t530;
    $[1229] = t531;
  } else {
    t531 = $[1229];
  }
  let t532;
  if ($[1230] !== t) {
    t532 = t("seoPaymentGateway:sections.4.subsections.10.title");
    $[1230] = t;
    $[1231] = t532;
  } else {
    t532 = $[1231];
  }
  let t533;
  if ($[1232] === Symbol.for("react.memo_cache_sentinel")) {
    t533 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1232] = t533;
  } else {
    t533 = $[1232];
  }
  let t534;
  if ($[1233] !== t) {
    t534 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.10.content" components={t533} />;
    $[1233] = t;
    $[1234] = t534;
  } else {
    t534 = $[1234];
  }
  let t535;
  if ($[1235] === Symbol.for("react.memo_cache_sentinel")) {
    t535 = {
      minorheader: <MinorHeader />
    };
    $[1235] = t535;
  } else {
    t535 = $[1235];
  }
  let t536;
  if ($[1236] !== t) {
    t536 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.10.subtitle1" components={t535} />;
    $[1236] = t;
    $[1237] = t536;
  } else {
    t536 = $[1237];
  }
  let t537;
  if ($[1238] !== t) {
    t537 = t("seoPaymentGateway:sections.4.subsections.10.props");
    $[1238] = t;
    $[1239] = t537;
  } else {
    t537 = $[1239];
  }
  let t538;
  if ($[1240] !== t537) {
    t538 = <PropsConsList items={[t537]} variant="props" />;
    $[1240] = t537;
    $[1241] = t538;
  } else {
    t538 = $[1241];
  }
  let t539;
  if ($[1242] === Symbol.for("react.memo_cache_sentinel")) {
    t539 = {
      minorheader: <MinorHeader />
    };
    $[1242] = t539;
  } else {
    t539 = $[1242];
  }
  let t540;
  if ($[1243] !== t) {
    t540 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.10.subtitle2" components={t539} />;
    $[1243] = t;
    $[1244] = t540;
  } else {
    t540 = $[1244];
  }
  let t541;
  if ($[1245] !== t) {
    t541 = t("seoPaymentGateway:sections.4.subsections.10.cons");
    $[1245] = t;
    $[1246] = t541;
  } else {
    t541 = $[1246];
  }
  let t542;
  if ($[1247] !== t541) {
    t542 = <PropsConsList items={[t541]} variant="cons" />;
    $[1247] = t541;
    $[1248] = t542;
  } else {
    t542 = $[1248];
  }
  let t543;
  if ($[1249] !== t) {
    t543 = t("seoPaymentGateway:sections.4.subsections.10.table.headers.1");
    $[1249] = t;
    $[1250] = t543;
  } else {
    t543 = $[1250];
  }
  let t544;
  if ($[1251] !== t543) {
    t544 = <th className="w-56 rounded-tr-none!">{t543}</th>;
    $[1251] = t543;
    $[1252] = t544;
  } else {
    t544 = $[1252];
  }
  let t545;
  if ($[1253] !== t) {
    t545 = t("seoPaymentGateway:sections.4.subsections.10.table.headers.2");
    $[1253] = t;
    $[1254] = t545;
  } else {
    t545 = $[1254];
  }
  let t546;
  if ($[1255] !== t545) {
    t546 = <th colSpan={2} className="w-64">{t545}</th>;
    $[1255] = t545;
    $[1256] = t546;
  } else {
    t546 = $[1256];
  }
  let t547;
  if ($[1257] !== t) {
    t547 = t("seoPaymentGateway:sections.4.subsections.10.table.headers.3");
    $[1257] = t;
    $[1258] = t547;
  } else {
    t547 = $[1258];
  }
  let t548;
  if ($[1259] !== t547) {
    t548 = <th colSpan={2} className="w-64 rounded-tr-md">{t547}</th>;
    $[1259] = t547;
    $[1260] = t548;
  } else {
    t548 = $[1260];
  }
  let t549;
  if ($[1261] !== t544 || $[1262] !== t546 || $[1263] !== t548) {
    t549 = <tr>{t544}{t546}{t548}</tr>;
    $[1261] = t544;
    $[1262] = t546;
    $[1263] = t548;
    $[1264] = t549;
  } else {
    t549 = $[1264];
  }
  let t550;
  if ($[1265] !== t) {
    t550 = t("seoPaymentGateway:sections.4.subsections.10.table.rows.1.columns.1");
    $[1265] = t;
    $[1266] = t550;
  } else {
    t550 = $[1266];
  }
  let t551;
  if ($[1267] !== t550) {
    t551 = <td className="w-56">{t550}</td>;
    $[1267] = t550;
    $[1268] = t551;
  } else {
    t551 = $[1268];
  }
  let t552;
  if ($[1269] !== t) {
    t552 = t("seoPaymentGateway:sections.4.subsections.10.table.rows.1.columns.2");
    $[1269] = t;
    $[1270] = t552;
  } else {
    t552 = $[1270];
  }
  let t553;
  if ($[1271] !== t552) {
    t553 = <td colSpan={2} className="w-64 text-left!">{t552}</td>;
    $[1271] = t552;
    $[1272] = t553;
  } else {
    t553 = $[1272];
  }
  let t554;
  if ($[1273] !== t) {
    t554 = t("seoPaymentGateway:sections.4.subsections.10.table.rows.1.columns.3");
    $[1273] = t;
    $[1274] = t554;
  } else {
    t554 = $[1274];
  }
  let t555;
  if ($[1275] !== t554) {
    t555 = <td colSpan={2} className="w-64 text-left!">{t554}</td>;
    $[1275] = t554;
    $[1276] = t555;
  } else {
    t555 = $[1276];
  }
  let t556;
  if ($[1277] !== t551 || $[1278] !== t553 || $[1279] !== t555) {
    t556 = <tr>{t551}{t553}{t555}</tr>;
    $[1277] = t551;
    $[1278] = t553;
    $[1279] = t555;
    $[1280] = t556;
  } else {
    t556 = $[1280];
  }
  let t557;
  if ($[1281] !== t549 || $[1282] !== t556) {
    t557 = <Table head={t549} body={t556} className="mt-8 mb-16" />;
    $[1281] = t549;
    $[1282] = t556;
    $[1283] = t557;
  } else {
    t557 = $[1283];
  }
  let t558;
  if ($[1284] !== t534 || $[1285] !== t536 || $[1286] !== t538 || $[1287] !== t540 || $[1288] !== t542 || $[1289] !== t557) {
    t558 = <>{t534}{t536}{t538}{t540}{t542}{t557}</>;
    $[1284] = t534;
    $[1285] = t536;
    $[1286] = t538;
    $[1287] = t540;
    $[1288] = t542;
    $[1289] = t557;
    $[1290] = t558;
  } else {
    t558 = $[1290];
  }
  let t559;
  if ($[1291] !== t532 || $[1292] !== t558) {
    t559 = {
      title: t532,
      content: t558
    };
    $[1291] = t532;
    $[1292] = t558;
    $[1293] = t559;
  } else {
    t559 = $[1293];
  }
  let t560;
  if ($[1294] !== t) {
    t560 = t("seoPaymentGateway:sections.4.subsections.11.title");
    $[1294] = t;
    $[1295] = t560;
  } else {
    t560 = $[1295];
  }
  let t561;
  if ($[1296] === Symbol.for("react.memo_cache_sentinel")) {
    t561 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1296] = t561;
  } else {
    t561 = $[1296];
  }
  let t562;
  if ($[1297] !== t) {
    t562 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.11.content" components={t561} />;
    $[1297] = t;
    $[1298] = t562;
  } else {
    t562 = $[1298];
  }
  let t563;
  if ($[1299] === Symbol.for("react.memo_cache_sentinel")) {
    t563 = {
      minorheader: <MinorHeader />
    };
    $[1299] = t563;
  } else {
    t563 = $[1299];
  }
  let t564;
  if ($[1300] !== t) {
    t564 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.11.subtitle1" components={t563} />;
    $[1300] = t;
    $[1301] = t564;
  } else {
    t564 = $[1301];
  }
  let t565;
  if ($[1302] !== t) {
    t565 = t("seoPaymentGateway:sections.4.subsections.11.props");
    $[1302] = t;
    $[1303] = t565;
  } else {
    t565 = $[1303];
  }
  let t566;
  if ($[1304] !== t565) {
    t566 = <PropsConsList items={[t565]} variant="props" />;
    $[1304] = t565;
    $[1305] = t566;
  } else {
    t566 = $[1305];
  }
  let t567;
  if ($[1306] === Symbol.for("react.memo_cache_sentinel")) {
    t567 = {
      minorheader: <MinorHeader />
    };
    $[1306] = t567;
  } else {
    t567 = $[1306];
  }
  let t568;
  if ($[1307] !== t) {
    t568 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.11.subtitle2" components={t567} />;
    $[1307] = t;
    $[1308] = t568;
  } else {
    t568 = $[1308];
  }
  let t569;
  if ($[1309] !== t) {
    t569 = t("seoPaymentGateway:sections.4.subsections.11.cons");
    $[1309] = t;
    $[1310] = t569;
  } else {
    t569 = $[1310];
  }
  let t570;
  if ($[1311] !== t569) {
    t570 = <PropsConsList items={[t569]} variant="cons" />;
    $[1311] = t569;
    $[1312] = t570;
  } else {
    t570 = $[1312];
  }
  let t571;
  if ($[1313] !== t) {
    t571 = t("seoPaymentGateway:sections.4.subsections.11.table.headers.1");
    $[1313] = t;
    $[1314] = t571;
  } else {
    t571 = $[1314];
  }
  let t572;
  if ($[1315] !== t571) {
    t572 = <th className="w-56 rounded-tr-none!">{t571}</th>;
    $[1315] = t571;
    $[1316] = t572;
  } else {
    t572 = $[1316];
  }
  let t573;
  if ($[1317] !== t) {
    t573 = t("seoPaymentGateway:sections.4.subsections.11.table.headers.2");
    $[1317] = t;
    $[1318] = t573;
  } else {
    t573 = $[1318];
  }
  let t574;
  if ($[1319] !== t573) {
    t574 = <th colSpan={2} className="w-64">{t573}</th>;
    $[1319] = t573;
    $[1320] = t574;
  } else {
    t574 = $[1320];
  }
  let t575;
  if ($[1321] !== t) {
    t575 = t("seoPaymentGateway:sections.4.subsections.11.table.headers.3");
    $[1321] = t;
    $[1322] = t575;
  } else {
    t575 = $[1322];
  }
  let t576;
  if ($[1323] !== t575) {
    t576 = <th colSpan={2} className="w-64 rounded-tr-md">{t575}</th>;
    $[1323] = t575;
    $[1324] = t576;
  } else {
    t576 = $[1324];
  }
  let t577;
  if ($[1325] !== t572 || $[1326] !== t574 || $[1327] !== t576) {
    t577 = <tr>{t572}{t574}{t576}</tr>;
    $[1325] = t572;
    $[1326] = t574;
    $[1327] = t576;
    $[1328] = t577;
  } else {
    t577 = $[1328];
  }
  let t578;
  if ($[1329] !== t) {
    t578 = t("seoPaymentGateway:sections.4.subsections.11.table.rows.1.columns.1");
    $[1329] = t;
    $[1330] = t578;
  } else {
    t578 = $[1330];
  }
  let t579;
  if ($[1331] !== t578) {
    t579 = <td className="w-56">{t578}</td>;
    $[1331] = t578;
    $[1332] = t579;
  } else {
    t579 = $[1332];
  }
  let t580;
  if ($[1333] !== t) {
    t580 = t("seoPaymentGateway:sections.4.subsections.11.table.rows.1.columns.2");
    $[1333] = t;
    $[1334] = t580;
  } else {
    t580 = $[1334];
  }
  let t581;
  if ($[1335] !== t580) {
    t581 = <td colSpan={2} className="w-64 text-left!">{t580}</td>;
    $[1335] = t580;
    $[1336] = t581;
  } else {
    t581 = $[1336];
  }
  let t582;
  if ($[1337] !== t) {
    t582 = t("seoPaymentGateway:sections.4.subsections.11.table.rows.1.columns.3");
    $[1337] = t;
    $[1338] = t582;
  } else {
    t582 = $[1338];
  }
  let t583;
  if ($[1339] !== t582) {
    t583 = <td colSpan={2} className="w-64 text-left!">{t582}</td>;
    $[1339] = t582;
    $[1340] = t583;
  } else {
    t583 = $[1340];
  }
  let t584;
  if ($[1341] !== t579 || $[1342] !== t581 || $[1343] !== t583) {
    t584 = <tr>{t579}{t581}{t583}</tr>;
    $[1341] = t579;
    $[1342] = t581;
    $[1343] = t583;
    $[1344] = t584;
  } else {
    t584 = $[1344];
  }
  let t585;
  if ($[1345] !== t577 || $[1346] !== t584) {
    t585 = <Table head={t577} body={t584} className="mt-8 mb-16" />;
    $[1345] = t577;
    $[1346] = t584;
    $[1347] = t585;
  } else {
    t585 = $[1347];
  }
  let t586;
  if ($[1348] !== t562 || $[1349] !== t564 || $[1350] !== t566 || $[1351] !== t568 || $[1352] !== t570 || $[1353] !== t585) {
    t586 = <>{t562}{t564}{t566}{t568}{t570}{t585}</>;
    $[1348] = t562;
    $[1349] = t564;
    $[1350] = t566;
    $[1351] = t568;
    $[1352] = t570;
    $[1353] = t585;
    $[1354] = t586;
  } else {
    t586 = $[1354];
  }
  let t587;
  if ($[1355] !== t560 || $[1356] !== t586) {
    t587 = {
      title: t560,
      content: t586
    };
    $[1355] = t560;
    $[1356] = t586;
    $[1357] = t587;
  } else {
    t587 = $[1357];
  }
  let t588;
  if ($[1358] !== t) {
    t588 = t("seoPaymentGateway:sections.4.subsections.12.title");
    $[1358] = t;
    $[1359] = t588;
  } else {
    t588 = $[1359];
  }
  let t589;
  if ($[1360] === Symbol.for("react.memo_cache_sentinel")) {
    t589 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1360] = t589;
  } else {
    t589 = $[1360];
  }
  let t590;
  if ($[1361] !== t) {
    t590 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.12.content" components={t589} />;
    $[1361] = t;
    $[1362] = t590;
  } else {
    t590 = $[1362];
  }
  let t591;
  if ($[1363] === Symbol.for("react.memo_cache_sentinel")) {
    t591 = {
      minorheader: <MinorHeader />
    };
    $[1363] = t591;
  } else {
    t591 = $[1363];
  }
  let t592;
  if ($[1364] !== t) {
    t592 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.12.subtitle1" components={t591} />;
    $[1364] = t;
    $[1365] = t592;
  } else {
    t592 = $[1365];
  }
  let t593;
  if ($[1366] === Symbol.for("react.memo_cache_sentinel")) {
    t593 = [...Array(2)];
    $[1366] = t593;
  } else {
    t593 = $[1366];
  }
  let t594;
  if ($[1367] !== t) {
    t594 = <PropsConsList items={t593.map((__9, i_9) => {
      const transIndex_9 = i_9 + 1 as NumericRange<1, 2>;
      return <Trans key={i_9} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.12.props.${transIndex_9}`} />;
    })} variant="props" />;
    $[1367] = t;
    $[1368] = t594;
  } else {
    t594 = $[1368];
  }
  let t595;
  if ($[1369] === Symbol.for("react.memo_cache_sentinel")) {
    t595 = {
      minorheader: <MinorHeader />
    };
    $[1369] = t595;
  } else {
    t595 = $[1369];
  }
  let t596;
  if ($[1370] !== t) {
    t596 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.12.subtitle2" components={t595} />;
    $[1370] = t;
    $[1371] = t596;
  } else {
    t596 = $[1371];
  }
  let t597;
  if ($[1372] === Symbol.for("react.memo_cache_sentinel")) {
    t597 = [...Array(2)];
    $[1372] = t597;
  } else {
    t597 = $[1372];
  }
  let t598;
  if ($[1373] !== t) {
    t598 = <PropsConsList items={t597.map((__10, i_10) => {
      const transIndex_10 = i_10 + 1 as NumericRange<1, 2>;
      return <Trans key={i_10} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.12.cons.${transIndex_10}`} />;
    })} variant="cons" />;
    $[1373] = t;
    $[1374] = t598;
  } else {
    t598 = $[1374];
  }
  let t599;
  if ($[1375] !== t) {
    t599 = t("seoPaymentGateway:sections.4.subsections.12.table.headers.1");
    $[1375] = t;
    $[1376] = t599;
  } else {
    t599 = $[1376];
  }
  let t600;
  if ($[1377] !== t599) {
    t600 = <th className="w-56 rounded-tr-none!">{t599}</th>;
    $[1377] = t599;
    $[1378] = t600;
  } else {
    t600 = $[1378];
  }
  let t601;
  if ($[1379] !== t) {
    t601 = t("seoPaymentGateway:sections.4.subsections.12.table.headers.2");
    $[1379] = t;
    $[1380] = t601;
  } else {
    t601 = $[1380];
  }
  let t602;
  if ($[1381] !== t601) {
    t602 = <th colSpan={2} className="w-64">{t601}</th>;
    $[1381] = t601;
    $[1382] = t602;
  } else {
    t602 = $[1382];
  }
  let t603;
  if ($[1383] !== t) {
    t603 = t("seoPaymentGateway:sections.4.subsections.12.table.headers.3");
    $[1383] = t;
    $[1384] = t603;
  } else {
    t603 = $[1384];
  }
  let t604;
  if ($[1385] !== t603) {
    t604 = <th colSpan={2} className="w-64 rounded-tr-md">{t603}</th>;
    $[1385] = t603;
    $[1386] = t604;
  } else {
    t604 = $[1386];
  }
  let t605;
  if ($[1387] !== t600 || $[1388] !== t602 || $[1389] !== t604) {
    t605 = <tr>{t600}{t602}{t604}</tr>;
    $[1387] = t600;
    $[1388] = t602;
    $[1389] = t604;
    $[1390] = t605;
  } else {
    t605 = $[1390];
  }
  let t606;
  if ($[1391] !== t) {
    t606 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.1.columns.1");
    $[1391] = t;
    $[1392] = t606;
  } else {
    t606 = $[1392];
  }
  let t607;
  if ($[1393] !== t606) {
    t607 = <td className="w-56">{t606}</td>;
    $[1393] = t606;
    $[1394] = t607;
  } else {
    t607 = $[1394];
  }
  let t608;
  if ($[1395] !== t) {
    t608 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.1.columns.2");
    $[1395] = t;
    $[1396] = t608;
  } else {
    t608 = $[1396];
  }
  let t609;
  if ($[1397] !== t608) {
    t609 = <td colSpan={2} className="w-64 text-left!">{t608}</td>;
    $[1397] = t608;
    $[1398] = t609;
  } else {
    t609 = $[1398];
  }
  let t610;
  if ($[1399] !== t) {
    t610 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.1.columns.3");
    $[1399] = t;
    $[1400] = t610;
  } else {
    t610 = $[1400];
  }
  let t611;
  if ($[1401] !== t610) {
    t611 = <td colSpan={2} className="w-64 text-left!">{t610}</td>;
    $[1401] = t610;
    $[1402] = t611;
  } else {
    t611 = $[1402];
  }
  let t612;
  if ($[1403] !== t607 || $[1404] !== t609 || $[1405] !== t611) {
    t612 = <tr>{t607}{t609}{t611}</tr>;
    $[1403] = t607;
    $[1404] = t609;
    $[1405] = t611;
    $[1406] = t612;
  } else {
    t612 = $[1406];
  }
  let t613;
  if ($[1407] !== t) {
    t613 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.2.columns.1");
    $[1407] = t;
    $[1408] = t613;
  } else {
    t613 = $[1408];
  }
  let t614;
  if ($[1409] !== t613) {
    t614 = <td className="w-56">{t613}</td>;
    $[1409] = t613;
    $[1410] = t614;
  } else {
    t614 = $[1410];
  }
  let t615;
  if ($[1411] !== t) {
    t615 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.2.columns.2");
    $[1411] = t;
    $[1412] = t615;
  } else {
    t615 = $[1412];
  }
  let t616;
  if ($[1413] !== t615) {
    t616 = <td colSpan={2} className="w-64 text-left!">{t615}</td>;
    $[1413] = t615;
    $[1414] = t616;
  } else {
    t616 = $[1414];
  }
  let t617;
  if ($[1415] !== t) {
    t617 = t("seoPaymentGateway:sections.4.subsections.12.table.rows.2.columns.3");
    $[1415] = t;
    $[1416] = t617;
  } else {
    t617 = $[1416];
  }
  let t618;
  if ($[1417] !== t617) {
    t618 = <td colSpan={2} className="w-64 text-left!">{t617}</td>;
    $[1417] = t617;
    $[1418] = t618;
  } else {
    t618 = $[1418];
  }
  let t619;
  if ($[1419] !== t614 || $[1420] !== t616 || $[1421] !== t618) {
    t619 = <tr>{t614}{t616}{t618}</tr>;
    $[1419] = t614;
    $[1420] = t616;
    $[1421] = t618;
    $[1422] = t619;
  } else {
    t619 = $[1422];
  }
  let t620;
  if ($[1423] !== t612 || $[1424] !== t619) {
    t620 = <>{t612}{t619}</>;
    $[1423] = t612;
    $[1424] = t619;
    $[1425] = t620;
  } else {
    t620 = $[1425];
  }
  let t621;
  if ($[1426] !== t605 || $[1427] !== t620) {
    t621 = <Table head={t605} body={t620} className="mt-8 mb-16" />;
    $[1426] = t605;
    $[1427] = t620;
    $[1428] = t621;
  } else {
    t621 = $[1428];
  }
  let t622;
  if ($[1429] !== t590 || $[1430] !== t592 || $[1431] !== t594 || $[1432] !== t596 || $[1433] !== t598 || $[1434] !== t621) {
    t622 = <>{t590}{t592}{t594}{t596}{t598}{t621}</>;
    $[1429] = t590;
    $[1430] = t592;
    $[1431] = t594;
    $[1432] = t596;
    $[1433] = t598;
    $[1434] = t621;
    $[1435] = t622;
  } else {
    t622 = $[1435];
  }
  let t623;
  if ($[1436] !== t588 || $[1437] !== t622) {
    t623 = {
      title: t588,
      content: t622
    };
    $[1436] = t588;
    $[1437] = t622;
    $[1438] = t623;
  } else {
    t623 = $[1438];
  }
  let t624;
  if ($[1439] !== t) {
    t624 = t("seoPaymentGateway:sections.4.subsections.13.title");
    $[1439] = t;
    $[1440] = t624;
  } else {
    t624 = $[1440];
  }
  let t625;
  if ($[1441] === Symbol.for("react.memo_cache_sentinel")) {
    t625 = {
      minorheader: <MinorHeader />
    };
    $[1441] = t625;
  } else {
    t625 = $[1441];
  }
  let t626;
  if ($[1442] !== t) {
    t626 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.13.subtitle1" components={t625} />;
    $[1442] = t;
    $[1443] = t626;
  } else {
    t626 = $[1443];
  }
  let t627;
  if ($[1444] !== t) {
    t627 = t("seoPaymentGateway:sections.4.subsections.13.props");
    $[1444] = t;
    $[1445] = t627;
  } else {
    t627 = $[1445];
  }
  let t628;
  if ($[1446] !== t627) {
    t628 = <PropsConsList items={[t627]} variant="props" />;
    $[1446] = t627;
    $[1447] = t628;
  } else {
    t628 = $[1447];
  }
  let t629;
  if ($[1448] === Symbol.for("react.memo_cache_sentinel")) {
    t629 = {
      minorheader: <MinorHeader />
    };
    $[1448] = t629;
  } else {
    t629 = $[1448];
  }
  let t630;
  if ($[1449] !== t) {
    t630 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.13.subtitle2" components={t629} />;
    $[1449] = t;
    $[1450] = t630;
  } else {
    t630 = $[1450];
  }
  let t631;
  if ($[1451] !== t) {
    t631 = t("seoPaymentGateway:sections.4.subsections.13.cons");
    $[1451] = t;
    $[1452] = t631;
  } else {
    t631 = $[1452];
  }
  let t632;
  if ($[1453] !== t631) {
    t632 = <PropsConsList items={[t631]} variant="cons" />;
    $[1453] = t631;
    $[1454] = t632;
  } else {
    t632 = $[1454];
  }
  let t633;
  if ($[1455] !== t) {
    t633 = t("seoPaymentGateway:sections.4.subsections.13.table.headers.1");
    $[1455] = t;
    $[1456] = t633;
  } else {
    t633 = $[1456];
  }
  let t634;
  if ($[1457] !== t633) {
    t634 = <th className="w-56 rounded-tr-none!">{t633}</th>;
    $[1457] = t633;
    $[1458] = t634;
  } else {
    t634 = $[1458];
  }
  let t635;
  if ($[1459] !== t) {
    t635 = t("seoPaymentGateway:sections.4.subsections.13.table.headers.2");
    $[1459] = t;
    $[1460] = t635;
  } else {
    t635 = $[1460];
  }
  let t636;
  if ($[1461] !== t635) {
    t636 = <th colSpan={2} className="w-64">{t635}</th>;
    $[1461] = t635;
    $[1462] = t636;
  } else {
    t636 = $[1462];
  }
  let t637;
  if ($[1463] !== t) {
    t637 = t("seoPaymentGateway:sections.4.subsections.13.table.headers.3");
    $[1463] = t;
    $[1464] = t637;
  } else {
    t637 = $[1464];
  }
  let t638;
  if ($[1465] !== t637) {
    t638 = <th colSpan={2} className="w-64 rounded-tr-md">{t637}</th>;
    $[1465] = t637;
    $[1466] = t638;
  } else {
    t638 = $[1466];
  }
  let t639;
  if ($[1467] !== t634 || $[1468] !== t636 || $[1469] !== t638) {
    t639 = <tr>{t634}{t636}{t638}</tr>;
    $[1467] = t634;
    $[1468] = t636;
    $[1469] = t638;
    $[1470] = t639;
  } else {
    t639 = $[1470];
  }
  let t640;
  if ($[1471] !== t) {
    t640 = t("seoPaymentGateway:sections.4.subsections.13.table.rows.1.columns.1");
    $[1471] = t;
    $[1472] = t640;
  } else {
    t640 = $[1472];
  }
  let t641;
  if ($[1473] !== t640) {
    t641 = <td className="w-56">{t640}</td>;
    $[1473] = t640;
    $[1474] = t641;
  } else {
    t641 = $[1474];
  }
  let t642;
  if ($[1475] !== t) {
    t642 = t("seoPaymentGateway:sections.4.subsections.13.table.rows.1.columns.2");
    $[1475] = t;
    $[1476] = t642;
  } else {
    t642 = $[1476];
  }
  let t643;
  if ($[1477] !== t642) {
    t643 = <td colSpan={2} className="w-64 text-left!">{t642}</td>;
    $[1477] = t642;
    $[1478] = t643;
  } else {
    t643 = $[1478];
  }
  let t644;
  if ($[1479] !== t) {
    t644 = t("seoPaymentGateway:sections.4.subsections.13.table.rows.1.columns.3");
    $[1479] = t;
    $[1480] = t644;
  } else {
    t644 = $[1480];
  }
  let t645;
  if ($[1481] !== t644) {
    t645 = <td colSpan={2} className="w-64 text-left!">{t644}</td>;
    $[1481] = t644;
    $[1482] = t645;
  } else {
    t645 = $[1482];
  }
  let t646;
  if ($[1483] !== t641 || $[1484] !== t643 || $[1485] !== t645) {
    t646 = <tr>{t641}{t643}{t645}</tr>;
    $[1483] = t641;
    $[1484] = t643;
    $[1485] = t645;
    $[1486] = t646;
  } else {
    t646 = $[1486];
  }
  let t647;
  if ($[1487] !== t639 || $[1488] !== t646) {
    t647 = <Table head={t639} body={t646} className="mt-8 mb-16" />;
    $[1487] = t639;
    $[1488] = t646;
    $[1489] = t647;
  } else {
    t647 = $[1489];
  }
  let t648;
  if ($[1490] === Symbol.for("react.memo_cache_sentinel")) {
    t648 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1490] = t648;
  } else {
    t648 = $[1490];
  }
  let t649;
  if ($[1491] !== t) {
    t649 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.13.content" components={t648} />;
    $[1491] = t;
    $[1492] = t649;
  } else {
    t649 = $[1492];
  }
  let t650;
  if ($[1493] !== t626 || $[1494] !== t628 || $[1495] !== t630 || $[1496] !== t632 || $[1497] !== t647 || $[1498] !== t649) {
    t650 = <>{t626}{t628}{t630}{t632}{t647}{t649}</>;
    $[1493] = t626;
    $[1494] = t628;
    $[1495] = t630;
    $[1496] = t632;
    $[1497] = t647;
    $[1498] = t649;
    $[1499] = t650;
  } else {
    t650 = $[1499];
  }
  let t651;
  if ($[1500] !== t624 || $[1501] !== t650) {
    t651 = {
      title: t624,
      content: t650
    };
    $[1500] = t624;
    $[1501] = t650;
    $[1502] = t651;
  } else {
    t651 = $[1502];
  }
  let t652;
  if ($[1503] !== t) {
    t652 = t("seoPaymentGateway:sections.4.subsections.14.title");
    $[1503] = t;
    $[1504] = t652;
  } else {
    t652 = $[1504];
  }
  let t653;
  if ($[1505] === Symbol.for("react.memo_cache_sentinel")) {
    t653 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1505] = t653;
  } else {
    t653 = $[1505];
  }
  let t654;
  if ($[1506] !== t) {
    t654 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.14.content" components={t653} />;
    $[1506] = t;
    $[1507] = t654;
  } else {
    t654 = $[1507];
  }
  let t655;
  if ($[1508] === Symbol.for("react.memo_cache_sentinel")) {
    t655 = {
      minorheader: <MinorHeader />,
      paragraph: <Paragraph />
    };
    $[1508] = t655;
  } else {
    t655 = $[1508];
  }
  let t656;
  if ($[1509] !== t) {
    t656 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.14.subtitle1" components={t655} />;
    $[1509] = t;
    $[1510] = t656;
  } else {
    t656 = $[1510];
  }
  let t657;
  if ($[1511] === Symbol.for("react.memo_cache_sentinel")) {
    t657 = [...Array(3)];
    $[1511] = t657;
  } else {
    t657 = $[1511];
  }
  let t658;
  if ($[1512] !== t) {
    t658 = <PropsConsList items={t657.map((__11, i_11) => {
      const transIndex_11 = i_11 + 1 as NumericRange<1, 3>;
      return <Trans key={i_11} t={t} i18nKey={`seoPaymentGateway:sections.4.subsections.14.props.${transIndex_11}`} />;
    })} variant="props" />;
    $[1512] = t;
    $[1513] = t658;
  } else {
    t658 = $[1513];
  }
  let t659;
  if ($[1514] === Symbol.for("react.memo_cache_sentinel")) {
    t659 = {
      minorheader: <MinorHeader />,
      paragraph: <Paragraph />
    };
    $[1514] = t659;
  } else {
    t659 = $[1514];
  }
  let t660;
  if ($[1515] !== t) {
    t660 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.subsections.14.subtitle2" components={t659} />;
    $[1515] = t;
    $[1516] = t660;
  } else {
    t660 = $[1516];
  }
  let t661;
  if ($[1517] !== t) {
    t661 = t("seoPaymentGateway:sections.4.subsections.14.cons");
    $[1517] = t;
    $[1518] = t661;
  } else {
    t661 = $[1518];
  }
  let t662;
  if ($[1519] !== t661) {
    t662 = <PropsConsList items={[t661]} variant="cons" />;
    $[1519] = t661;
    $[1520] = t662;
  } else {
    t662 = $[1520];
  }
  let t663;
  if ($[1521] !== t) {
    t663 = t("seoPaymentGateway:sections.4.subsections.14.table.headers.1");
    $[1521] = t;
    $[1522] = t663;
  } else {
    t663 = $[1522];
  }
  let t664;
  if ($[1523] !== t663) {
    t664 = <th className="w-56 rounded-tr-none!">{t663}</th>;
    $[1523] = t663;
    $[1524] = t664;
  } else {
    t664 = $[1524];
  }
  let t665;
  if ($[1525] !== t) {
    t665 = t("seoPaymentGateway:sections.4.subsections.14.table.headers.2");
    $[1525] = t;
    $[1526] = t665;
  } else {
    t665 = $[1526];
  }
  let t666;
  if ($[1527] !== t665) {
    t666 = <th colSpan={2} className="w-64">{t665}</th>;
    $[1527] = t665;
    $[1528] = t666;
  } else {
    t666 = $[1528];
  }
  let t667;
  if ($[1529] !== t) {
    t667 = t("seoPaymentGateway:sections.4.subsections.14.table.headers.3");
    $[1529] = t;
    $[1530] = t667;
  } else {
    t667 = $[1530];
  }
  let t668;
  if ($[1531] !== t667) {
    t668 = <th colSpan={2} className="w-64 rounded-tr-md">{t667}</th>;
    $[1531] = t667;
    $[1532] = t668;
  } else {
    t668 = $[1532];
  }
  let t669;
  if ($[1533] !== t664 || $[1534] !== t666 || $[1535] !== t668) {
    t669 = <tr>{t664}{t666}{t668}</tr>;
    $[1533] = t664;
    $[1534] = t666;
    $[1535] = t668;
    $[1536] = t669;
  } else {
    t669 = $[1536];
  }
  let t670;
  if ($[1537] !== t) {
    t670 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.1.columns.1");
    $[1537] = t;
    $[1538] = t670;
  } else {
    t670 = $[1538];
  }
  let t671;
  if ($[1539] !== t670) {
    t671 = <td className="w-56">{t670}</td>;
    $[1539] = t670;
    $[1540] = t671;
  } else {
    t671 = $[1540];
  }
  let t672;
  if ($[1541] !== t) {
    t672 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.1.columns.2");
    $[1541] = t;
    $[1542] = t672;
  } else {
    t672 = $[1542];
  }
  let t673;
  if ($[1543] !== t672) {
    t673 = <td colSpan={2} className="w-64 text-left!">{t672}</td>;
    $[1543] = t672;
    $[1544] = t673;
  } else {
    t673 = $[1544];
  }
  let t674;
  if ($[1545] !== t) {
    t674 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.1.columns.3");
    $[1545] = t;
    $[1546] = t674;
  } else {
    t674 = $[1546];
  }
  let t675;
  if ($[1547] !== t674) {
    t675 = <td colSpan={2} className="w-64 text-left!">{t674}</td>;
    $[1547] = t674;
    $[1548] = t675;
  } else {
    t675 = $[1548];
  }
  let t676;
  if ($[1549] !== t671 || $[1550] !== t673 || $[1551] !== t675) {
    t676 = <tr>{t671}{t673}{t675}</tr>;
    $[1549] = t671;
    $[1550] = t673;
    $[1551] = t675;
    $[1552] = t676;
  } else {
    t676 = $[1552];
  }
  let t677;
  if ($[1553] !== t) {
    t677 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.2.columns.1");
    $[1553] = t;
    $[1554] = t677;
  } else {
    t677 = $[1554];
  }
  let t678;
  if ($[1555] !== t677) {
    t678 = <td className="w-56">{t677}</td>;
    $[1555] = t677;
    $[1556] = t678;
  } else {
    t678 = $[1556];
  }
  let t679;
  if ($[1557] !== t) {
    t679 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.2.columns.2");
    $[1557] = t;
    $[1558] = t679;
  } else {
    t679 = $[1558];
  }
  let t680;
  if ($[1559] !== t679) {
    t680 = <td colSpan={2} className="w-64 text-left!">{t679}</td>;
    $[1559] = t679;
    $[1560] = t680;
  } else {
    t680 = $[1560];
  }
  let t681;
  if ($[1561] !== t) {
    t681 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.2.columns.3");
    $[1561] = t;
    $[1562] = t681;
  } else {
    t681 = $[1562];
  }
  let t682;
  if ($[1563] !== t681) {
    t682 = <td colSpan={2} className="w-64 text-left!">{t681}</td>;
    $[1563] = t681;
    $[1564] = t682;
  } else {
    t682 = $[1564];
  }
  let t683;
  if ($[1565] !== t678 || $[1566] !== t680 || $[1567] !== t682) {
    t683 = <tr>{t678}{t680}{t682}</tr>;
    $[1565] = t678;
    $[1566] = t680;
    $[1567] = t682;
    $[1568] = t683;
  } else {
    t683 = $[1568];
  }
  let t684;
  if ($[1569] !== t) {
    t684 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.3.columns.1");
    $[1569] = t;
    $[1570] = t684;
  } else {
    t684 = $[1570];
  }
  let t685;
  if ($[1571] !== t684) {
    t685 = <td className="w-56">{t684}</td>;
    $[1571] = t684;
    $[1572] = t685;
  } else {
    t685 = $[1572];
  }
  let t686;
  if ($[1573] !== t) {
    t686 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.3.columns.2");
    $[1573] = t;
    $[1574] = t686;
  } else {
    t686 = $[1574];
  }
  let t687;
  if ($[1575] !== t686) {
    t687 = <td colSpan={2} className="w-64 text-left!">{t686}</td>;
    $[1575] = t686;
    $[1576] = t687;
  } else {
    t687 = $[1576];
  }
  let t688;
  if ($[1577] !== t) {
    t688 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.3.columns.3");
    $[1577] = t;
    $[1578] = t688;
  } else {
    t688 = $[1578];
  }
  let t689;
  if ($[1579] !== t688) {
    t689 = <td colSpan={2} className="w-64 text-left!">{t688}</td>;
    $[1579] = t688;
    $[1580] = t689;
  } else {
    t689 = $[1580];
  }
  let t690;
  if ($[1581] !== t685 || $[1582] !== t687 || $[1583] !== t689) {
    t690 = <tr>{t685}{t687}{t689}</tr>;
    $[1581] = t685;
    $[1582] = t687;
    $[1583] = t689;
    $[1584] = t690;
  } else {
    t690 = $[1584];
  }
  let t691;
  if ($[1585] !== t) {
    t691 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.4.columns.1");
    $[1585] = t;
    $[1586] = t691;
  } else {
    t691 = $[1586];
  }
  let t692;
  if ($[1587] !== t691) {
    t692 = <td className="w-56">{t691}</td>;
    $[1587] = t691;
    $[1588] = t692;
  } else {
    t692 = $[1588];
  }
  let t693;
  if ($[1589] !== t) {
    t693 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.4.columns.2");
    $[1589] = t;
    $[1590] = t693;
  } else {
    t693 = $[1590];
  }
  let t694;
  if ($[1591] !== t693) {
    t694 = <td colSpan={2} className="w-64 text-left!">{t693}</td>;
    $[1591] = t693;
    $[1592] = t694;
  } else {
    t694 = $[1592];
  }
  let t695;
  if ($[1593] !== t) {
    t695 = t("seoPaymentGateway:sections.4.subsections.14.table.rows.4.columns.3");
    $[1593] = t;
    $[1594] = t695;
  } else {
    t695 = $[1594];
  }
  let t696;
  if ($[1595] !== t695) {
    t696 = <td colSpan={2} className="w-64 text-left!">{t695}</td>;
    $[1595] = t695;
    $[1596] = t696;
  } else {
    t696 = $[1596];
  }
  let t697;
  if ($[1597] !== t692 || $[1598] !== t694 || $[1599] !== t696) {
    t697 = <tr>{t692}{t694}{t696}</tr>;
    $[1597] = t692;
    $[1598] = t694;
    $[1599] = t696;
    $[1600] = t697;
  } else {
    t697 = $[1600];
  }
  let t698;
  if ($[1601] !== t676 || $[1602] !== t683 || $[1603] !== t690 || $[1604] !== t697) {
    t698 = <>{t676}{t683}{t690}{t697}</>;
    $[1601] = t676;
    $[1602] = t683;
    $[1603] = t690;
    $[1604] = t697;
    $[1605] = t698;
  } else {
    t698 = $[1605];
  }
  let t699;
  if ($[1606] !== t) {
    t699 = t("seoPaymentGateway:sections.4.subsections.14.table.notes");
    $[1606] = t;
    $[1607] = t699;
  } else {
    t699 = $[1607];
  }
  let t700;
  if ($[1608] !== t699) {
    t700 = [t699];
    $[1608] = t699;
    $[1609] = t700;
  } else {
    t700 = $[1609];
  }
  let t701;
  if ($[1610] !== t669 || $[1611] !== t698 || $[1612] !== t700) {
    t701 = <Table head={t669} body={t698} notes={t700} className="mt-8" />;
    $[1610] = t669;
    $[1611] = t698;
    $[1612] = t700;
    $[1613] = t701;
  } else {
    t701 = $[1613];
  }
  let t702;
  if ($[1614] !== t654 || $[1615] !== t656 || $[1616] !== t658 || $[1617] !== t660 || $[1618] !== t662 || $[1619] !== t701) {
    t702 = <>{t654}{t656}{t658}{t660}{t662}{t701}</>;
    $[1614] = t654;
    $[1615] = t656;
    $[1616] = t658;
    $[1617] = t660;
    $[1618] = t662;
    $[1619] = t701;
    $[1620] = t702;
  } else {
    t702 = $[1620];
  }
  let t703;
  if ($[1621] !== t652 || $[1622] !== t702) {
    t703 = {
      title: t652,
      content: t702
    };
    $[1621] = t652;
    $[1622] = t702;
    $[1623] = t703;
  } else {
    t703 = $[1623];
  }
  let t704;
  if ($[1624] !== t101 || $[1625] !== t181 || $[1626] !== t286 || $[1627] !== t360 || $[1628] !== t388 || $[1629] !== t438 || $[1630] !== t488 || $[1631] !== t531 || $[1632] !== t559 || $[1633] !== t587 || $[1634] !== t623 || $[1635] !== t651 || $[1636] !== t703 || $[1637] !== t73) {
    t704 = [t73, t101, t181, t286, t360, t388, t438, t488, t531, t559, t587, t623, t651, t703];
    $[1624] = t101;
    $[1625] = t181;
    $[1626] = t286;
    $[1627] = t360;
    $[1628] = t388;
    $[1629] = t438;
    $[1630] = t488;
    $[1631] = t531;
    $[1632] = t559;
    $[1633] = t587;
    $[1634] = t623;
    $[1635] = t651;
    $[1636] = t703;
    $[1637] = t73;
    $[1638] = t704;
  } else {
    t704 = $[1638];
  }
  let t705;
  if ($[1639] === Symbol.for("react.memo_cache_sentinel")) {
    t705 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1639] = t705;
  } else {
    t705 = $[1639];
  }
  let t706;
  if ($[1640] !== t) {
    t706 = <Trans t={t} i18nKey="seoPaymentGateway:sections.4.content" components={t705} />;
    $[1640] = t;
    $[1641] = t706;
  } else {
    t706 = $[1641];
  }
  let t707;
  if ($[1642] === Symbol.for("react.memo_cache_sentinel")) {
    t707 = [...Array(4)];
    $[1642] = t707;
  } else {
    t707 = $[1642];
  }
  let t708;
  if ($[1643] !== t) {
    t708 = <UnorderedList items={t707.map((__12, i_12) => {
      const transIndex_12 = i_12 + 1 as NumericRange<1, 4>;
      return <Trans key={i_12} t={t} i18nKey={`seoPaymentGateway:sections.4.list.${transIndex_12}`} />;
    })} className="mb-16" />;
    $[1643] = t;
    $[1644] = t708;
  } else {
    t708 = $[1644];
  }
  let t709;
  if ($[1645] !== t706 || $[1646] !== t708) {
    t709 = <>{t706}{t708}</>;
    $[1645] = t706;
    $[1646] = t708;
    $[1647] = t709;
  } else {
    t709 = $[1647];
  }
  let t710;
  if ($[1648] !== t28 || $[1649] !== t704 || $[1650] !== t709) {
    t710 = {
      title: t28,
      subsections: t704,
      content: t709
    };
    $[1648] = t28;
    $[1649] = t704;
    $[1650] = t709;
    $[1651] = t710;
  } else {
    t710 = $[1651];
  }
  let t711;
  if ($[1652] !== t) {
    t711 = t("seoPaymentGateway:sections.5.title");
    $[1652] = t;
    $[1653] = t711;
  } else {
    t711 = $[1653];
  }
  let t712;
  if ($[1654] === Symbol.for("react.memo_cache_sentinel")) {
    t712 = {
      paragraph: <Paragraph />
    };
    $[1654] = t712;
  } else {
    t712 = $[1654];
  }
  let t713;
  if ($[1655] !== t) {
    t713 = <Trans t={t} i18nKey="seoPaymentGateway:sections.5.content" components={t712} />;
    $[1655] = t;
    $[1656] = t713;
  } else {
    t713 = $[1656];
  }
  let t714;
  if ($[1657] === Symbol.for("react.memo_cache_sentinel")) {
    t714 = [...Array(5)];
    $[1657] = t714;
  } else {
    t714 = $[1657];
  }
  let t715;
  if ($[1658] !== t) {
    t715 = <UnorderedList items={t714.map((__13, i_13) => {
      const transIndex_13 = i_13 + 1 as NumericRange<1, 5>;
      return <Trans key={i_13} t={t} i18nKey={`seoPaymentGateway:sections.5.list.${transIndex_13}`} />;
    })} />;
    $[1658] = t;
    $[1659] = t715;
  } else {
    t715 = $[1659];
  }
  let t716;
  if ($[1660] !== t713 || $[1661] !== t715) {
    t716 = <>{t713}{t715}</>;
    $[1660] = t713;
    $[1661] = t715;
    $[1662] = t716;
  } else {
    t716 = $[1662];
  }
  let t717;
  if ($[1663] !== t711 || $[1664] !== t716) {
    t717 = {
      title: t711,
      content: t716
    };
    $[1663] = t711;
    $[1664] = t716;
    $[1665] = t717;
  } else {
    t717 = $[1665];
  }
  let t718;
  if ($[1666] !== t) {
    t718 = t("seoPaymentGateway:sections.6.title");
    $[1666] = t;
    $[1667] = t718;
  } else {
    t718 = $[1667];
  }
  let t719;
  if ($[1668] === Symbol.for("react.memo_cache_sentinel")) {
    t719 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1668] = t719;
  } else {
    t719 = $[1668];
  }
  let t720;
  if ($[1669] !== t) {
    t720 = <Trans t={t} i18nKey="seoPaymentGateway:sections.6.content" components={t719} />;
    $[1669] = t;
    $[1670] = t720;
  } else {
    t720 = $[1670];
  }
  let t721;
  if ($[1671] !== t718 || $[1672] !== t720) {
    t721 = {
      title: t718,
      content: t720
    };
    $[1671] = t718;
    $[1672] = t720;
    $[1673] = t721;
  } else {
    t721 = $[1673];
  }
  let t722;
  if ($[1674] !== t) {
    t722 = t("seoPaymentGateway:sections.7.title");
    $[1674] = t;
    $[1675] = t722;
  } else {
    t722 = $[1675];
  }
  let t723;
  if ($[1676] === Symbol.for("react.memo_cache_sentinel")) {
    t723 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[1676] = t723;
  } else {
    t723 = $[1676];
  }
  let t724;
  if ($[1677] !== t) {
    t724 = <Trans t={t} i18nKey="seoPaymentGateway:sections.7.content" components={t723} />;
    $[1677] = t;
    $[1678] = t724;
  } else {
    t724 = $[1678];
  }
  let t725;
  if ($[1679] === Symbol.for("react.memo_cache_sentinel")) {
    t725 = LINKS();
    $[1679] = t725;
  } else {
    t725 = $[1679];
  }
  const t726 = t725.homepage;
  let t727;
  if ($[1680] !== t) {
    t727 = t("seoPaymentGateway:sections.7.button");
    $[1680] = t;
    $[1681] = t727;
  } else {
    t727 = $[1681];
  }
  let t728;
  if ($[1682] !== t727) {
    t728 = <Button analyticsParam="linktToHomepage" testId="linktToHomepage" to={t726} variant="primary">{t727}</Button>;
    $[1682] = t727;
    $[1683] = t728;
  } else {
    t728 = $[1683];
  }
  let t729;
  if ($[1684] !== t724 || $[1685] !== t728) {
    t729 = <>{t724}{t728}</>;
    $[1684] = t724;
    $[1685] = t728;
    $[1686] = t729;
  } else {
    t729 = $[1686];
  }
  let t730;
  if ($[1687] !== t722 || $[1688] !== t729) {
    t730 = {
      title: t722,
      content: t729
    };
    $[1687] = t722;
    $[1688] = t729;
    $[1689] = t730;
  } else {
    t730 = $[1689];
  }
  let t731;
  if ($[1690] !== t14 || $[1691] !== t23 || $[1692] !== t27 || $[1693] !== t710 || $[1694] !== t717 || $[1695] !== t721 || $[1696] !== t730) {
    t731 = [t14, t23, t27, t710, t717, t721, t730];
    $[1690] = t14;
    $[1691] = t23;
    $[1692] = t27;
    $[1693] = t710;
    $[1694] = t717;
    $[1695] = t721;
    $[1696] = t730;
    $[1697] = t731;
  } else {
    t731 = $[1697];
  }
  let t732;
  if ($[1698] !== menuPromoBanners || $[1699] !== t10 || $[1700] !== t4 || $[1701] !== t5 || $[1702] !== t7 || $[1703] !== t731) {
    t732 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t4} title={t5} intro={t7} introButton={t10} sections={t731} />;
    $[1698] = menuPromoBanners;
    $[1699] = t10;
    $[1700] = t4;
    $[1701] = t5;
    $[1702] = t7;
    $[1703] = t731;
    $[1704] = t732;
  } else {
    t732 = $[1704];
  }
  return t732;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('platebni-brana');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoPaymentGateway']))
    }
  };
};